import { DateTimeUtils, NavigationModule } from 'UI-Dash-Commons-UI';
import DocsMenuSection from '../types/DocsMenuSection';
import TableContents from '../types/TableContents';
import {
    ACCOUNT_INFO_COMPONENT_TABLE_CONTENTS,
    ADMOB_INTERGRATION_COMPONENT_TABLE_CONTENTS,
    ADOBE_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    ADOBE_BANNERS_COMPONENT_TABLE_CONTENTS,
    ADOBE_ERROR_CODE_COMPONENT_TABLE_CONTENTS,
    ADOBE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    AD_REVIEW_RULES_MGMT_TABLE_CONTENTS,
    AD_REVIEW_USER_JOURNEY_TABLE_CONTENTS,
    ADVANCED_FEATURES_AB_TESTING_TABLE_CONTENTS,
    ADVANCED_FEATURES_AD_REVIEW_TABLE_CONTENTS,
    ADVANCED_FEATURES_AD_UNIT_AUTOMATION_API_TABLE_CONTENTS,
    ADVANCED_FEATURES_DIRECT_SOLD_TABLE_CONTENTS,
    ADVANCED_FEATURES_TABLE_CONTENTS,
    ADVANCED_FEATURES_WATERFALL_SEGMENTATION_TABLE_CONTENTS,
    ADVANCED_SETUP_COMPONENT_TABLE_CONTENTS,
    AMAZON_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    ANDROID_123_MIGRATION_TABLE_CONTENTS,
    ANDROID_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    ANDROID_APP_OPEN_TABLE_CONTENTS,
    ANDROID_BANNERS_COMPONENT_TABLE_CONTENTS,
    ANDROID_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    ANDROID_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    ANDROID_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    ANDROID_INTERSTITIALS_COMPONENT_TABLE_CONTENTS,
    ANDROID_MANUAL_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    ANDROID_MEDIATION_ADAPTER_COMPONENT_TABLE_CONTENTS,
    ANDROID_NATIVE_AD_PLACER_COMPONENT_TABLE_CONTENTS,
    ANDROID_NATIVE_COMPONENT_TABLE_CONTENTS,
    ANDROID_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS,
    ANDROID_PRIVACY_COMPONENT_TABLE_CONTENTS,
    APP_ADS_TXT_INFO_COMPONENT_TABLE_CONTENTS,
    AUTO_REDIRECTS_TABLE_CONTENTS,
    BEST_PRACTICES_COMPONENT_TABLE_CONTENTS,
    BICF_PRIVACY_COMPONENT_TABLE_CONTENTS,
    CAMPAIGN_MANAGEMENT_CONTENTS,
    CHARTBOOT_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    CORDOVA_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    CORDOVA_BANNERS_COMPONENT_TABLE_CONTENTS,
    CORDOVA_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    CORDOVA_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    CORDOVA_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS,
    CORDOVA_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS,
    CREATIVE_DEBUGGER_COMPONENT_TABLE_CONTENTS,
    CSJ_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    CUSTOM_ADAPTER_ANDROID_TABLE_CONTENTS,
    CUSTOM_ADAPTER_IOS_TABLE_CONTENTS,
    CUSTOM_SDK_COMPONENT_TABLE_CONTENTS,
    DEFOLD_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    DEFOLD_BANNERS_COMPONENT_TABLE_CONTENTS,
    DEFOLD_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    DEFOLD_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    DEFOLD_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS,
    DEFOLD_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS,
    DSPS_REPORTING_TABLE_CONTENTS,
    DSPS_SKADNETWORK_TABLE_CONTENTS,
    DSPS_TESTING_TABLE_CONTENTS,
    DSPS_VIEWABILITY_TABLE_CONTENTS,
    DV360_TABLE_CONTENTS,
    ERROR_CODE_COMPONENT_TABLE_CONTENTS,
    FACEBOOK_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    FLUTTER_APP_OPEN_TABLE_CONTENTS,
    FLUTTER_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    FLUTTER_BANNERS_COMPONENT_TABLE_CONTENTS,
    FLUTTER_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    FLUTTER_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS,
    FLUTTER_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    FLUTTER_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    FLUTTER_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS,
    FLUTTER_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS,
    FYBERMARKETPLACE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    GET_STARTED_WITH_MAX_OVERVIEW_TABLE_CONTENTS,
    GODOT_APP_OPEN_TABLE_CONTENTS,
    GODOT_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    GODOT_BANNERS_COMPONENT_TABLE_CONTENTS,
    GODOT_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS,
    GODOT_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    GODOT_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    GODOT_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS,
    GODOT_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS,
    GOOGLE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    HYPRMX_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    INMOBI_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    INTERSTITIALS_COMPONENT_TABLE_CONTENTS,
    IOS_123_MIGRATION_TABLE_CONTENTS,
    IOS_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    IOS_APP_OPEN_TABLE_CONTENTS,
    IOS_BANNERS_COMPONENT_TABLE_CONTENTS,
    IOS_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    IOS_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    IOS_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    IOS_MANUAL_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    IOS_MEDIATION_ADAPTER_COMPONENT_TABLE_CONTENTS,
    IOS_NATIVE_AD_PLACER_COMPONENT_TABLE_CONTENTS,
    IOS_NATIVE_COMPONENT_TABLE_CONTENTS,
    IOS_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS,
    IOS_SKADNETWORK_COMPONENT_TABLE_CONTENTS,
    IRONSOURCE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    LINE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    MAIO_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    MAX_S2S_IMPRESSION_REVENUE_COMPONENT_TABLE_CONTENTS,
    MAX_S2S_REWARDED_CALLBACK_COMPONENT_TABLE_CONTENTS,
    MEDIATION_DEBUGGER_COMPONENT_TABLE_CONTENTS,
    MINTEGRAL_INTERGRATION_COMPONENT_TABLE_CONTENTS,
    MOBILEFUSE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    MYTARGET_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    OGURY_PRESAGE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    ORTB_INTRODUCTION_TABLE_CONTENTS,
    ORTB_BID_REQUEST_TABLE_CONTENTS,
    ORTB_BID_RESPONSE_TABLE_CONTENTS,
    ORTB_CREATIVE_TYPES_TABLE_CONTENTS,
    PANGLE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    PAYMENTS_COMPONENT_TABLE_CONTENTS,
    PRIVACY_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_APP_OPEN_TABLE_CONTENTS,
    REACT_NATIVE_BANNERS_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS,
    REPORTING_APIS_AD_REVENUE_COMPONENT_TABLE_CONTENTS,
    REPORTING_APIS_COHORT_COMPONENT_TABLE_CONTENTS,
    REPORTING_APIS_USER_AD_REVENUE_COMPONENT_TABLE_CONTENTS,
    REWARDED_ADS_COMPONENT_TABLE_CONTENTS,
    REWARDED_ADS_COMPONENT_TABLE_CONTENTS_2,
    SMAATO_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    SWIFTUI_COMPONENT_TABLE_CONTENTS,
    TENCENT_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    TEST_MODE_TABLE_CONTENTS,
    UNITYADS_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    UNITY_APP_OPEN_TABLE_CONTENTS,
    UNITY_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    UNITY_AMAZON_COMPONENT_TABLE_CONTENTS,
    UNITY_BANNERS_COMPONENT_TABLE_CONTENTS,
    UNITY_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    UNITY_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    UNITY_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    UNITY_MEDIATION_ADAPTER_COMPONENT_TABLE_CONTENTS,
    UNREAL_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    UNREAL_BANNERS_COMPONENT_TABLE_CONTENTS,
    UNREAL_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    UNREAL_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    UNREAL_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS,
    UNREAL_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS,
    VERVE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    VUNGLE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    WATERFALL_MGMT_COMPONENT_TABLE_CONTENTS,
    YANDEX_INTEGRATION_COMPONENT_TABLE_CONTENTS,
} from './TableContentsSectionWrapper';

// TODO all routes maps should be passed from the back-end and not be statically defined in this utils
export const DOCS_BOTTOM_MENU: Array<DocsMenuSection> =
    [
        {
            displayName: 'Terms',
            id: '_terms',
            isPage: true,
            url: 'https://www.applovin.com/terms',
            children: [],
        },
        {
            displayName: 'Privacy',
            id: '_privacy',
            isPage: true,
            url: 'https://www.applovin.com/privacy',
            children: [],
        },
        {
            displayName: 'Support',
            id: '_support',
            isPage: true,
            url: 'https://www.applovin.com/support',
            children: [],
        },
        {
            displayName: 'Your Privacy Choices',
            id: '_privacy_ca_residents',
            isPage: true,
            url: 'https://www.applovin.com/privacy-ca-residents',
            icon: {
                iconSrc: require( `../images/menu/privacy-choices-opt-out-icon.svg` ),
                iconAlt: 'California Consumer Privacy Act (CCPA) Opt-Out Icon',
            },
            children: [],
        },
        {
            displayName: 'Cookies Settings',
            id: '_one_trust_sdk',
            isPage: true,
            url: NavigationModule.constants.ONE_TRUST_SDK_URL,
            children: [],
        },
        {
            displayName: 'EULA',
            id: '_eula',
            isPage: true,
            url: 'https://www.applovin.com/eula',
            children: [],
        },
        {
            displayName: 'DMCA',
            id: '_dmca',
            isPage: true,
            url: 'https://www.applovin.com/dmca/',
            children: [],
        }
    ];

export const DOCS_BOTTOM_MENU_TITLE = `Copyright ${DateTimeUtils.getUtcToday().getUTCFullYear()} by AppLovin`;

export const DOCS_RIGHT_SIDE_MENU_TABLE_CONTENT: Array<TableContents> = [
    ACCOUNT_INFO_COMPONENT_TABLE_CONTENTS,
    ADMOB_INTERGRATION_COMPONENT_TABLE_CONTENTS,
    ADOBE_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    ADOBE_BANNERS_COMPONENT_TABLE_CONTENTS,
    ADOBE_ERROR_CODE_COMPONENT_TABLE_CONTENTS,
    ADOBE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    AD_REVIEW_RULES_MGMT_TABLE_CONTENTS,
    AD_REVIEW_USER_JOURNEY_TABLE_CONTENTS,
    ADVANCED_FEATURES_AB_TESTING_TABLE_CONTENTS,
    ADVANCED_FEATURES_AD_REVIEW_TABLE_CONTENTS,
    ADVANCED_FEATURES_AD_UNIT_AUTOMATION_API_TABLE_CONTENTS,
    ADVANCED_FEATURES_DIRECT_SOLD_TABLE_CONTENTS,
    ADVANCED_FEATURES_TABLE_CONTENTS,
    ADVANCED_FEATURES_WATERFALL_SEGMENTATION_TABLE_CONTENTS,
    ADVANCED_SETUP_COMPONENT_TABLE_CONTENTS,
    AMAZON_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    ANDROID_123_MIGRATION_TABLE_CONTENTS,
    ANDROID_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    ANDROID_APP_OPEN_TABLE_CONTENTS,
    ANDROID_BANNERS_COMPONENT_TABLE_CONTENTS,
    ANDROID_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    ANDROID_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    ANDROID_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    ANDROID_INTERSTITIALS_COMPONENT_TABLE_CONTENTS,
    ANDROID_MANUAL_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    ANDROID_MEDIATION_ADAPTER_COMPONENT_TABLE_CONTENTS,
    ANDROID_NATIVE_AD_PLACER_COMPONENT_TABLE_CONTENTS,
    ANDROID_NATIVE_COMPONENT_TABLE_CONTENTS,
    ANDROID_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS,
    ANDROID_PRIVACY_COMPONENT_TABLE_CONTENTS,
    APP_ADS_TXT_INFO_COMPONENT_TABLE_CONTENTS,
    AUTO_REDIRECTS_TABLE_CONTENTS,
    BEST_PRACTICES_COMPONENT_TABLE_CONTENTS,
    BICF_PRIVACY_COMPONENT_TABLE_CONTENTS,
    CAMPAIGN_MANAGEMENT_CONTENTS,
    CHARTBOOT_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    CORDOVA_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    CORDOVA_BANNERS_COMPONENT_TABLE_CONTENTS,
    CORDOVA_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    CORDOVA_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    CORDOVA_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS,
    CORDOVA_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS,
    CREATIVE_DEBUGGER_COMPONENT_TABLE_CONTENTS,
    CSJ_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    CUSTOM_ADAPTER_ANDROID_TABLE_CONTENTS,
    CUSTOM_ADAPTER_IOS_TABLE_CONTENTS,
    CUSTOM_SDK_COMPONENT_TABLE_CONTENTS,
    DEFOLD_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    DEFOLD_BANNERS_COMPONENT_TABLE_CONTENTS,
    DEFOLD_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    DEFOLD_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    DEFOLD_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS,
    DEFOLD_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS,
    DSPS_REPORTING_TABLE_CONTENTS,
    DSPS_SKADNETWORK_TABLE_CONTENTS,
    DSPS_TESTING_TABLE_CONTENTS,
    DSPS_VIEWABILITY_TABLE_CONTENTS,
    DV360_TABLE_CONTENTS,
    ERROR_CODE_COMPONENT_TABLE_CONTENTS,
    FACEBOOK_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    FLUTTER_APP_OPEN_TABLE_CONTENTS,
    FLUTTER_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    FLUTTER_BANNERS_COMPONENT_TABLE_CONTENTS,
    FLUTTER_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    FLUTTER_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS,
    FLUTTER_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    FLUTTER_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    FLUTTER_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS,
    FLUTTER_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS,
    FYBERMARKETPLACE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    GET_STARTED_WITH_MAX_OVERVIEW_TABLE_CONTENTS,
    GODOT_APP_OPEN_TABLE_CONTENTS,
    GODOT_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    GODOT_BANNERS_COMPONENT_TABLE_CONTENTS,
    GODOT_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS,
    GODOT_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    GODOT_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    GODOT_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS,
    GODOT_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS,
    GOOGLE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    HYPRMX_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    INMOBI_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    INTERSTITIALS_COMPONENT_TABLE_CONTENTS,
    IOS_123_MIGRATION_TABLE_CONTENTS,
    IOS_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    IOS_APP_OPEN_TABLE_CONTENTS,
    IOS_BANNERS_COMPONENT_TABLE_CONTENTS,
    IOS_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    IOS_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    IOS_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    IOS_MANUAL_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    IOS_MEDIATION_ADAPTER_COMPONENT_TABLE_CONTENTS,
    IOS_NATIVE_AD_PLACER_COMPONENT_TABLE_CONTENTS,
    IOS_NATIVE_COMPONENT_TABLE_CONTENTS,
    IOS_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS,
    IOS_SKADNETWORK_COMPONENT_TABLE_CONTENTS,
    IRONSOURCE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    LINE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    MAIO_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    MAX_S2S_IMPRESSION_REVENUE_COMPONENT_TABLE_CONTENTS,
    MAX_S2S_REWARDED_CALLBACK_COMPONENT_TABLE_CONTENTS,
    MEDIATION_DEBUGGER_COMPONENT_TABLE_CONTENTS,
    MINTEGRAL_INTERGRATION_COMPONENT_TABLE_CONTENTS,
    MOBILEFUSE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    MYTARGET_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    OGURY_PRESAGE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    ORTB_INTRODUCTION_TABLE_CONTENTS,
    ORTB_BID_REQUEST_TABLE_CONTENTS,
    ORTB_BID_RESPONSE_TABLE_CONTENTS,
    ORTB_CREATIVE_TYPES_TABLE_CONTENTS,
    PANGLE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    PAYMENTS_COMPONENT_TABLE_CONTENTS,
    PRIVACY_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_APP_OPEN_TABLE_CONTENTS,
    REACT_NATIVE_BANNERS_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS,
    REACT_NATIVE_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS,
    REPORTING_APIS_AD_REVENUE_COMPONENT_TABLE_CONTENTS,
    REPORTING_APIS_COHORT_COMPONENT_TABLE_CONTENTS,
    REPORTING_APIS_USER_AD_REVENUE_COMPONENT_TABLE_CONTENTS,
    REWARDED_ADS_COMPONENT_TABLE_CONTENTS,
    REWARDED_ADS_COMPONENT_TABLE_CONTENTS_2,
    SMAATO_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    SWIFTUI_COMPONENT_TABLE_CONTENTS,
    TENCENT_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    TEST_MODE_TABLE_CONTENTS,
    UNITYADS_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    UNITY_APP_OPEN_TABLE_CONTENTS,
    UNITY_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    UNITY_AMAZON_COMPONENT_TABLE_CONTENTS,
    UNITY_BANNERS_COMPONENT_TABLE_CONTENTS,
    UNITY_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    UNITY_DATA_PASSING_COMPONENT_TABLE_CONTENTS,
    UNITY_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    UNITY_MEDIATION_ADAPTER_COMPONENT_TABLE_CONTENTS,
    UNREAL_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS,
    UNREAL_BANNERS_COMPONENT_TABLE_CONTENTS,
    UNREAL_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS,
    UNREAL_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    UNREAL_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS,
    UNREAL_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS,
    VERVE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    VUNGLE_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    WATERFALL_MGMT_COMPONENT_TABLE_CONTENTS,
    YANDEX_INTEGRATION_COMPONENT_TABLE_CONTENTS,
]

const GET_STARTED_WITH_MAX_MENU = {
    breadcrumbUrl: '/documentation/mediation/max/get-started-with-max',
    displayName: 'Getting Started',
    id: '_welcome_to_max',
    isPage: true,
    url: '/documentation/mediation/max/get-started-with-max',
    children: []
};

const MAX_UI_MENU = {
    breadcrumbUrl: '/documentation/mediation/ui-max/ad-units/create-ad-unit',
    displayName: 'MAX Dashboard',
    id: '_max_ui',
    isPage: true,
    url: '/documentation/mediation/ui-max',
    children:
        [
            {
                breadcrumbUrl: '/documentation/mediation/ui-max/ad-units/create-ad-unit',
                displayName: 'Ad Units',
                id: '_max_ui_ad_units',
                isPage: true,
                url: '/documentation/mediation/ui-max/ad-units',
                children:
                    [
                        {
                            displayName: 'Create Ad Unit',
                            id: '__max_ui_ad_units_create',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/ad-units/create-ad-unit',
                            children: []
                        },
                        {
                            displayName: 'Enabling Networks',
                            id: '__max_ui_ad_units_enabling_networks',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/ad-units/enabling-networks',
                            children: []
                        },
                        {
                            displayName: 'Advanced Setup',
                            id: '__max_ui_ad_units_advanced_setup',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/ad-units/advanced-setup',
                            children: []
                        },
                        {
                            displayName: 'Waterfall Management Tools',
                            id: '__max_ui_ad_units_waterfall_management_tools',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/ad-units/waterfall-management-tools',
                            children: []
                        }
                    ]
            },
            {
                breadcrumbUrl: '/documentation/mediation/ui-max/networks/connect-networks',
                displayName: 'Networks',
                id: '_max_ui_networks',
                isPage: true,
                url: '/documentation/mediation/ui-max/networks',
                children:
                    [
                        {
                            displayName: 'Connect Networks',
                            id: '__max_ui_networks_connect_networks',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/networks/connect-networks',
                            children: []
                        },
                        {
                            displayName: 'Auto CPM',
                            id: '__max_ui_networks_auto_cpm',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/networks/auto-cpm',
                            children: []
                        }
                    ]
            },
            {
                breadcrumbUrl: '/documentation/mediation/ui-max/reports/performance-reporting',
                displayName: 'Reports',
                id: '_max_ui_reports',
                isPage: true,
                url: '/documentation/mediation/ui-max/reports',
                children:
                    [
                        {
                            displayName: 'Performance Reporting',
                            id: '__max_ui_reports_performance_reporting',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/reports/performance-reporting',
                            children: []
                        },
                        {
                            displayName: 'User Activity',
                            id: '__max_ui_reports_user_activity',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/reports/user-activity',
                            children: []
                        },
                        {
                            displayName: 'Advanced Reporting',
                            id: '__max_ui_reports_advanced_reporting',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/reports/advanced-reporting',
                            children: []
                        },
                        {
                            displayName: 'ALX Reporting',
                            id: '__max_ui_reports_alx_reporting',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/reports/alx-reporting',
                            children: []
                        },
                        {
                            displayName: 'Scheduled Reports',
                            id: '__max_ui_reports_scheduled_reports',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/reports/scheduled-reports',
                            children: []
                        },
                        {
                            displayName: 'Cohorts',
                            id: '__max_ui_reports_cohorts',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/reports/cohorts',
                            children: []
                        },
                        {
                            displayName: 'Direct Sold',
                            id: '__max_ui_reports_direct_sold',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/reports/direct-sold',
                            children: []
                        },
                        {
                            displayName: 'Network Comparison',
                            id: '__max_ui_reports_network_comparison',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/reports/network-comparison',
                            children: []
                        },
                        {
                            displayName: 'Reporting APIs',
                            id: '__max_ui_reports_reporting_apis',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/reports/reporting-apis',
                            children: []
                        }
                    ]
            },
            {
                breadcrumbUrl: '/documentation/mediation/ui-max/account/general-account-info',
                displayName: 'Account',
                id: '_max_ui_account',
                isPage: true,
                url: '/documentation/mediation/ui-max/account',
                children:
                    [
                        {
                            displayName: 'Account Info',
                            id: '__max_ui_account_general_account_info',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/account/general-account-info',
                            children: []
                        },
                        {
                            displayName: 'app-ads.txt Info',
                            id: '__max_ui_account_app_ads_txt_info',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/account/app-ads-txt-info',
                            children: []
                        },
                        {
                            displayName: 'Users',
                            id: '__max_ui_account_users',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/account/users',
                            children: []
                        },
                        {
                            displayName: 'Payments',
                            id: '__max_ui_account_payments',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/account/payments',
                            children: []
                        },
                        {
                            displayName: 'Best Practices',
                            id: '__max_ui_account_best_practices',
                            isPage: true,
                            url: '/documentation/mediation/ui-max/account/best-practices',
                            children: []
                        }
                    ]
            }
        ],
};

const MAX_AUCTIONS = {
    breadcrumbUrl: '/documentation/mediation/auctions/getting-started/integration',
    displayName: 'Demand Partners',
    id: '_bidding',
    isPage: true,
    url: '/documentation/mediation/auctions',
    children: [
        {
            displayName: 'Campaign API',
            id: '__auctions_campaign_api',
            isPage: true,
            url: '/documentation/mediation/auctions/campaign-management-api',
            children: [],
        },
        {
            displayName: 'Auction Dynamics',
            id: '__auctions_audtion_dynamics',
            isPage: true,
            url: '/documentation/mediation/auctions/auction-dynamics',
            children: [],
        },
        {
            displayName: 'Custom Adapter',
            id: '__auctions_custom_adapter',
            isPage: true,
            url: '/documentation/mediation/auctions/custom-adapter',
            children:
                [
                    {
                        breadcrumbUrl: '/documentation/mediation/auctions/custom-adapter-android',
                        displayName: 'Android',
                        id: '___auctions_custom_adapter_android',
                        isPage: true,
                        url: '/documentation/mediation/auctions/custom-adapter-android',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/auctions/custom-adapter-ios',
                        displayName: 'iOS',
                        id: '___auctions_custom_adapter_ios',
                        isPage: true,
                        url: '/documentation/mediation/auctions/custom-adapter-ios',
                        children: [],
                    },
                ],
        },
        {
            displayName: 'DSPs',
            id: '__auctions_dsps',
            isPage: true,
            url: '/documentation/mediation/auctions/dsps',
            children:
                [
                    {
                        breadcrumbUrl: '/documentation/mediation/auctions/dsps/ortb-spec/',
                        displayName: 'oRTB Specification:',
                        id: '_ortb',
                        isPage: true,
                        url: '/documentation/mediation/auctions/dsps/ortb-spec/introduction',
                        children: [
                            {
                                breadcrumbUrl: '/documentation/mediation/auctions/dsps/ortb-spec/introduction',
                                displayName: 'Introduction',
                                id: '_ortb_introduction',
                                isPage: true,
                                url: '/documentation/mediation/auctions/dsps/ortb-spec/introduction',
                                children: [
                                ]
                            },
                            {
                                breadcrumbUrl: '/documentation/mediation/auctions/dsps/ortb-spec/bid-request',
                                displayName: 'Bid Request',
                                id: '_ortb_bid_request',
                                isPage: true,
                                url: '/documentation/mediation/auctions/dsps/ortb-spec/bid-request',
                                children: [
                                ]
                            },
                            {
                                breadcrumbUrl: '/documentation/mediation/auctions/dsps/ortb-spec/bid-response',
                                displayName: 'Bid Response',
                                id: '_ortb_bid_response',
                                isPage: true,
                                url: '/documentation/mediation/auctions/dsps/ortb-spec/bid-response',
                                children: [
                                ]
                            },
                            {
                                breadcrumbUrl: '/documentation/mediation/auctions/dsps/ortb-spec/creative-types',
                                displayName: 'Creative Types',
                                id: '_ortb_creative_types',
                                isPage: true,
                                url: '/documentation/mediation/auctions/dsps/ortb-spec/creative-types',
                                children: [
                                ]
                            },
                            {
                                breadcrumbUrl: '/documentation/mediation/auctions/dsps/ortb-spec/changelog',
                                displayName: 'Changelog',
                                id: '_ortb_changelog',
                                isPage: true,
                                url: '/documentation/mediation/auctions/dsps/ortb-spec/changelog',
                                children: [
                                ]
                            },
                        ]
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/auctions/dsps/reporting',
                        displayName: 'DSP Integration and Compliance',
                        id: '_dsp_integration_and_compliance',
                        isPage: true,
                        url: '/documentation/mediation/auctions/dsps/reporting',
                        children: [
                            {
                                breadcrumbUrl: '/documentation/mediation/auctions/dsps/reporting',
                                displayName: 'Report APIs',
                                id: '___auctions_dsps_reporting',
                                isPage: true,
                                url: '/documentation/mediation/auctions/dsps/reporting',
                                children: [],
                            },
                            {
                                breadcrumbUrl: '/documentation/mediation/auctions/dsps/testing',
                                displayName: 'Testing',
                                id: '___auctions_dsps_testing',
                                isPage: true,
                                url: '/documentation/mediation/auctions/dsps/testing',
                                children: [],
                            },
                            {
                                breadcrumbUrl: '/documentation/mediation/auctions/dsps/skadnetwork',
                                displayName: 'SKAdNetwork',
                                id: '___auctions_dsps_skadnetwork',
                                isPage: true,
                                url: '/documentation/mediation/auctions/dsps/skadnetwork',
                                children: [],
                            },
                            {
                                breadcrumbUrl: '/documentation/mediation/auctions/dsps/viewability',
                                displayName: 'Viewability',
                                id: '___auctions_dsps_viewability',
                                isPage: true,
                                url: '/documentation/mediation/auctions/dsps/viewability',
                                children: [],
                            },
                            {
                                breadcrumbUrl: '/documentation/mediation/auctions/dsps/gdpr-deleted-device-ids-api',
                                displayName: 'GDPR Deleted Device IDs API',
                                id: '___auctions_dsps_dpgr_deleted_device_ids_api',
                                isPage: true,
                                url: '/documentation/mediation/auctions/dsps/gdpr-deleted-device-ids-api',
                                children: [],
                            },
                        ]
                    },
                ],
        },
        {
            displayName: 'DV360',
            id: '__auctions_dv360',
            isPage: true,
            url: '/documentation/mediation/auctions/dv360',
            children: [],
        },
    ],
};

const ADOBE_AIR_DOCS_MENU = {
    breadcrumbUrl: '/documentation/mediation/adobe-air/getting-started/integration',
    displayName: 'Adobe AIR',
    id: '_adobe_air',
    isPage: true,
    url: '/documentation/mediation/adobe-air',
    children: [
            {
                displayName: 'Overview',
                id: '__adobe_air_getting_started',
                isPage: true,
                url: '/documentation/mediation/adobe-air/getting-started',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/adobe-air/getting-started/integration',
                            displayName: 'Integration',
                            id: '___adobe_air_getting_started_integration',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/getting-started/integration',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/adobe-air/getting-started/privacy',
                            displayName: 'Privacy',
                            id: '___adobe_air_getting_started_privacy',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/getting-started/privacy',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/adobe-air/getting-started/apple-privacy-manifests',
                            displayName: 'Privacy Manifests',
                            id: '___adobe_air_getting_started_apple_manifests',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/getting-started/apple-privacy-manifests',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/adobe-air/getting-started/errorcodes',
                            displayName: 'Error Handling',
                            id: '___adobe_air_getting_started_errorcodes',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/getting-started/errorcodes',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/adobe-air/getting-started/skadnetwork-info',
                            displayName: 'SKAdNetwork',
                            id: '___adobe_air_getting_started_skadnetwork_info',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/getting-started/skadnetwork-info',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/adobe-air/getting-started/advanced-settings',
                            displayName: 'Advanced Settings',
                            id: '___adobe_air_getting_started_advanced_settings',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/getting-started/advanced-settings',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Ad Formats',
                id: '__adobe_air_ad_formats',
                isPage: true,
                url: '/documentation/mediation/adobe-air/ad-formats',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/adobe-air/ad-formats/banners',
                            displayName: 'Banners & MRECs',
                            id: '___adobe_air_ad_formats_banner_ads',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/ad-formats/banners',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/adobe-air/ad-formats/interstitials',
                            displayName: 'Interstitials',
                            id: '___adobe_air_ad_formats_interstitial_ads',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/ad-formats/interstitials',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/adobe-air/ad-formats/rewarded-ads',
                            displayName: 'Rewarded',
                            id: '___adobe_air_ad_formats_rewarded_ads',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/ad-formats/rewarded-ads',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Preparing Mediated Networks',
                id: '__adobe_air_mediation_adapters',
                isPage: true,
                url: '/documentation/mediation/adobe-air/mediation-adapters',
                children: [],
            },
            {
                breadcrumbUrl: '/documentation/mediation/adobe-air/mediation-setup',
                displayName: 'Mediated Network Guides',
                id: '__adobe_air_mediation_setup',
                isPage: true,
                url: '/documentation/mediation/adobe-air/mediation-setup',
                children:
                    [
                        {
                            displayName: 'Bidders',
                            id: '___adobe_air_mediation_setup_bidders',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/mediation-setup/bidders',
                            children:
                                [
                                    {
                                        displayName: 'BidMachine',
                                        id: '___adobe_air_mediation_setup_bidmachine',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/bidmachine',
                                        children: [],
                                    },
                                    {
                                        displayName: 'DT Exchange',
                                        id: '___adobe_air_mediation_setup_fyber',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/fyber-marketplace',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Google',
                                        id: '___adobe_air_mediation_setup_google',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/google',
                                        children: [],
                                    },
                                    {
                                        displayName: 'InMobi',
                                        id: '___adobe_air_mediation_setup_inmobi',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/inmobi',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Liftoff Monetize',
                                        id: '___adobe_air_mediation_setup_liftoff',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/liftoff',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Meta Audience Network',
                                        id: '___adobe_air_mediation_setup_facebook',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/facebook',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Mintegral',
                                        id: '___adobe_air_mediation_setup_mintegral',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/mintegral',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Ogury',
                                        id: '___adobe_air_mediation_setup_ogury_presage',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/ogury-presage',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Pangle',
                                        id: '___adobe_air_mediation_setup_tiktok',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/pangle',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Smaato',
                                        id: '___adobe_air_mediation_setup_smaato',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/smaato',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Unity Ads',
                                        id: '___adobe_air_mediation_setup_unityads',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/unityads',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Verve',
                                        id: '___adobe_air_mediation_setup_verve',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/verve',
                                        children: [],
                                    },
                                    {
                                        displayName: 'VK Ad Network',
                                        id: '___adobe_air_mediation_setup_vkadnetwork',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/vkadnetwork',
                                        children: [],
                                    },
                                ]
                        },
                        {
                            displayName: 'Others',
                            id: '___adobe_air_mediation_setup_others',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/mediation-setup/others',
                            children:
                                [
                                    {
                                        displayName: 'AdMob',
                                        id: '___adobe_air_mediation_setup_admob',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/admob',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Chartboost',
                                        id: '___adobe_air_mediation_setup_chartboost',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/chartboost',
                                        children: [],
                                    },
                                    {
                                        displayName: 'CSJ',
                                        id: '___adobe_air_mediation_setup_csj',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/csj',
                                        children: [],
                                    },
                                    {
                                        displayName: 'HyprMX',
                                        id: '___adobe_air_mediation_setup_hyprmx',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/hyprmx',
                                        children: [],
                                    },
                                    {
                                        displayName: 'IronSource',
                                        id: '___adobe_air_mediation_setup_ironsource',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/ironsource',
                                        children: [],
                                    },
                                    {
                                        displayName: 'LINE',
                                        id: '___adobe_air_mediation_setup_line',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/line',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Maio',
                                        id: '___adobe_air_mediation_setup_maio',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/maio',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Yandex',
                                        id: '___adobe_air_mediation_setup_yandex',
                                        isPage: true,
                                        url: '/documentation/mediation/adobe-air/mediation-setup/yandex',
                                        children: []
                                    },
                                ]
                        },
                        {
                            displayName: 'Custom SDK Networks',
                            id: '___adobe_air_mediation_setup_custom_sdk',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/mediation-setup/custom-sdk',
                            children: []
                        }
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/adobe-air/testing-networks/test-mode',
                displayName: 'Testing Networks',
                id: '__adobe_air_testing_networks',
                isPage: true,
                url: '/documentation/mediation/adobe-air/testing-networks',
                children:
                    [
                        {
                            displayName: 'Demo App',
                            id: '___adobe_air_demo_app',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/testing-networks/demo-app',
                            children: [],
                        },
                        {
                            displayName: 'Creative Debugger',
                            id: '___adobe_air_creative_debugger',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/testing-networks/creative-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Mediation Debugger',
                            id: '___adobe_air_mediation_debugger',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/testing-networks/mediation-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Test Mode',
                            id: '___adobe_air_test_mode',
                            isPage: true,
                            url: '/documentation/mediation/adobe-air/testing-networks/test-mode',
                            children: [],
                        },
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/adobe-air/changelog',
                displayName: 'Changelog',
                id: '__adobe_air_sdk_change_logs',
                isPage: true,
                url: '/documentation/mediation/adobe-air/changelog',
                children: [],
            },
        ],
};
const ANDROID_DOCS_MENU = {
    breadcrumbUrl: '/documentation/mediation/android/getting-started/integration',
    displayName: 'Android / Amazon',
    id: '_android',
    isPage: true,
    url: '/documentation/mediation/android',
    children:
        [
            {
                displayName: 'Overview',
                id: '__android_getting_started',
                isPage: true,
                url: '/documentation/mediation/android/getting-started',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/android/getting-started/integration',
                            displayName: 'Integration',
                            id: '___android_getting_started_integration',
                            isPage: true,
                            url: '/documentation/mediation/android/getting-started/integration',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/android/getting-started/migration123',
                            displayName: 'New SDK Initialization API (beta)',
                            id: '___android_getting_started_migration123',
                            isPage: true,
                            url: '/documentation/mediation/android/getting-started/migration123',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/android/getting-started/terms-and-privacy-policy-flow',
                            displayName: 'Terms and Privacy Policy Flow',
                            id: '___android_getting_started_terms_and_privacy_policy_flow',
                            isPage: true,
                            url: '/documentation/mediation/android/getting-started/terms-and-privacy-policy-flow',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/android/getting-started/privacy',
                            displayName: 'Privacy',
                            id: '___android_getting_started_privacy',
                            isPage: true,
                            url: '/documentation/mediation/android/getting-started/privacy',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/android/getting-started/errorcodes',
                            displayName: 'Error Handling',
                            id: '___android_getting_started_errorcodes',
                            isPage: true,
                            url: '/documentation/mediation/android/getting-started/errorcodes',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/android/getting-started/data-passing',
                            displayName: 'Data and Keyword Passing',
                            id: '___android_getting_started_data_passing',
                            isPage: true,
                            url: '/documentation/mediation/android/getting-started/data-passing',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/android/getting-started/advanced-settings',
                            displayName: 'Advanced Settings',
                            id: '___android_getting_started_advanced_settings',
                            isPage: true,
                            url: '/documentation/mediation/android/getting-started/advanced-settings',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Ad Formats',
                id: '__android_ad_formats',
                isPage: true,
                url: '/documentation/mediation/android/ad-formats',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/android/ad-formats/app-open',
                            displayName: 'App Open',
                            id: '___android_ad_formats_app_open',
                            isPage: true,
                            url: '/documentation/mediation/android/ad-formats/app-open',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/android/ad-formats/banners',
                            displayName: 'Banners & MRECs',
                            id: '___android_ad_formats_banner_ads',
                            isPage: true,
                            url: '/documentation/mediation/android/ad-formats/banners',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/android/ad-formats/interstitials',
                            displayName: 'Interstitials',
                            id: '___android_ad_formats_interstitial_ads',
                            isPage: true,
                            url: '/documentation/mediation/android/ad-formats/interstitials',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/android/ad-formats/native-templates',
                            displayName: 'Native (Templates)',
                            id: '___android_ad_formats_native_templates',
                            isPage: true,
                            url: '/documentation/mediation/android/ad-formats/native-templates',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/android/ad-formats/native-manual',
                            displayName: 'Native (Manual)',
                            id: '___android_ad_formats_native_manual',
                            isPage: true,
                            url: '/documentation/mediation/android/ad-formats/native-manual',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/android/ad-formats/native-ad-placer',
                            displayName: 'Native (Ad Placer)',
                            id: '___android_ad_formats_native_ad_placer',
                            isPage: true,
                            url: '/documentation/mediation/android/ad-formats/native-ad-placer',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/android/ad-formats/rewarded-ads',
                            displayName: 'Rewarded',
                            id: '___android_ad_formats_rewarded_ads',
                            isPage: true,
                            url: '/documentation/mediation/android/ad-formats/rewarded-ads',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Preparing Mediated Networks',
                id: '__android_mediation_adapters',
                isPage: true,
                url: '/documentation/mediation/android/mediation-adapters',
                children: [],
            },
            {
                breadcrumbUrl: '/documentation/mediation/android/mediation-setup',
                displayName: 'Mediated Network Guides',
                id: '__android_mediation_setup',
                isPage: true,
                url: '/documentation/mediation/android/mediation-setup',
                children:
                    [
                        {
                            displayName: 'Bidders',
                            id: '___android_mediation_setup_bidders',
                            isPage: true,
                            url: '/documentation/mediation/android/mediation-setup/bidders',
                            children:
                                [
                                    {
                                        displayName: 'Amazon',
                                        id: '___android_mediation_setup_amazon',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/amazon',
                                        children: [],
                                    },
                                    {
                                        displayName: 'BidMachine',
                                        id: '___android_mediation_setup_bidmachine',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/bidmachine',
                                        children: [],
                                    },
                                    {
                                        displayName: 'DT Exchange',
                                        id: '___android_mediation_setup_fyber',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/fyber-marketplace',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Google',
                                        id: '___android_mediation_setup_google',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/google',
                                        children: [],
                                    },
                                    {
                                        displayName: 'InMobi',
                                        id: '___android_mediation_setup_inmobi',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/inmobi',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Liftoff Monetize',
                                        id: '___android_mediation_setup_liftoff',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/liftoff',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Meta Audience Network',
                                        id: '___android_mediation_setup_facebook',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/facebook',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Mintegral',
                                        id: '___android_mediation_setup_mintegral',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/mintegral',
                                        children: [],
                                    },
                                    {
                                        displayName: 'MobileFuse',
                                        id: '___android_mediation_setup_mobilefuse',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/mobilefuse',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Ogury',
                                        id: '___android_mediation_setup_ogury_presage',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/ogury-presage',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Pangle',
                                        id: '___android_mediation_setup_tiktok',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/pangle',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Smaato',
                                        id: '___android_mediation_setup_smaato',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/smaato',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Unity Ads',
                                        id: '___android_mediation_setup_unityads',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/unityads',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Verve',
                                        id: '___android_mediation_setup_verve',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/verve',
                                        children: [],
                                    },
                                    {
                                        displayName: 'VK Ad Network',
                                        id: '___android_mediation_setup_vkadnetwork',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/vkadnetwork',
                                        children: [],
                                    },
                                ]
                        },
                        {
                            displayName: 'Others',
                            id: '___android_mediation_setup_others',
                            isPage: true,
                            url: '/documentation/mediation/android/mediation-setup/others',
                            children:
                                [
                                    {
                                        displayName: 'AdMob',
                                        id: '___android_mediation_setup_admob',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/admob',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Chartboost',
                                        id: '___android_mediation_setup_chartboost',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/chartboost',
                                        children: [],
                                    },
                                    {
                                        displayName: 'HyprMX',
                                        id: '___android_mediation_setup_hyprmx',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/hyprmx',
                                        children: [],
                                    },
                                    {
                                        displayName: 'IronSource',
                                        id: '___android_mediation_setup_ironsource',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/ironsource',
                                        children: [],
                                    },
                                    {
                                        displayName: 'LINE',
                                        id: '___android_mediation_setup_line',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/line',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Maio',
                                        id: '___android_mediation_setup_maio',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/maio',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Yandex',
                                        id: '___android_mediation_setup_yandex',
                                        isPage: true,
                                        url: '/documentation/mediation/android/mediation-setup/yandex',
                                        children: []
                                    },
                                ]
                        },
                        {
                            displayName: 'Custom SDK Networks',
                            id: '___android_mediation_setup_custom_sdk',
                            isPage: true,
                            url: '/documentation/mediation/android/mediation-setup/custom-sdk',
                            children: []
                        }
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/android/testing-networks/test-mode',
                displayName: 'Testing Networks',
                id: '__android_testing_networks',
                isPage: true,
                url: '/documentation/mediation/android/testing-networks',
                children:
                    [
                        {
                            displayName: 'Demo App',
                            id: '___android_demo_app',
                            isPage: true,
                            url: '/documentation/mediation/android/testing-networks/demo-app',
                            children: [],
                        },
                        {
                            displayName: 'Creative Debugger',
                            id: '___android_creative_debugger',
                            isPage: true,
                            url: '/documentation/mediation/android/testing-networks/creative-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Mediation Debugger',
                            id: '___android_mediation_debugger',
                            isPage: true,
                            url: '/documentation/mediation/android/testing-networks/mediation-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Test Mode',
                            id: '___android_test_mode',
                            isPage: true,
                            url: '/documentation/mediation/android/testing-networks/test-mode',
                            children: [],
                        },
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/android/changelog',
                displayName: 'Changelog',
                id: '__android_sdk_change_logs',
                isPage: true,
                url: '/documentation/mediation/android/changelog',
                children: [],
            },
        ],
};
const IOS_DOCS_MENU = {
    breadcrumbUrl: '/documentation/mediation/ios/getting-started/integration',
    displayName: 'iOS',
    id: '_ios',
    isPage: true,
    url: '/documentation/mediation/ios',
    children:
        [
            {
                displayName: 'Overview',
                id: '__ios_getting_started',
                isPage: true,
                url: '/documentation/mediation/ios/getting-started',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/getting-started/integration',
                            displayName: 'Integration',
                            id: '___ios_getting_started_integration',
                            isPage: true,
                            url: '/documentation/mediation/ios/getting-started/integration',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/getting-started/migration123',
                            displayName: 'New SDK Initialization API (beta)',
                            id: '___ios_getting_started_migration123',
                            isPage: true,
                            url: '/documentation/mediation/ios/getting-started/migration123',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/getting-started/terms-and-privacy-policy-flow',
                            displayName: 'Terms and Privacy Policy Flow',
                            id: '___ios_getting_started_terms_and_privacy_policy_flow',
                            isPage: true,
                            url: '/documentation/mediation/ios/getting-started/terms-and-privacy-policy-flow',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/getting-started/privacy',
                            displayName: 'Privacy',
                            id: '___ios_getting_started_privacy',
                            isPage: true,
                            url: '/documentation/mediation/ios/getting-started/privacy',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/getting-started/apple-privacy-manifests',
                            displayName: 'Privacy Manifests',
                            id: '___ios_getting_started_apple_manifests',
                            isPage: true,
                            url: '/documentation/mediation/ios/getting-started/apple-privacy-manifests',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/getting-started/errorcodes',
                            displayName: 'Error Handling',
                            id: '___ios_getting_started_errorcodes',
                            isPage: true,
                            url: '/documentation/mediation/ios/getting-started/errorcodes',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/getting-started/skadnetwork-info',
                            displayName: 'SKAdNetwork',
                            id: '___ios_getting_started_skadnetwork_info',
                            isPage: true,
                            url: '/documentation/mediation/ios/getting-started/skadnetwork-info',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/getting-started/data-passing',
                            displayName: 'Data and Keyword Passing',
                            id: '___ios_getting_started_data_passing',
                            isPage: true,
                            url: '/documentation/mediation/ios/getting-started/data-passing',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/getting-started/advanced-settings',
                            displayName: 'Advanced Settings',
                            id: '___ios_getting_started_advanced_settings',
                            isPage: true,
                            url: '/documentation/mediation/ios/getting-started/advanced-settings',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Ad Formats',
                id: '__ios_ad_formats',
                isPage: true,
                url: '/documentation/mediation/ios/ad-formats',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/ad-formats/app-open',
                            displayName: 'App Open',
                            id: '___ios_ad_formats_app_open',
                            isPage: true,
                            url: '/documentation/mediation/ios/ad-formats/app-open',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/ad-formats/banners',
                            displayName: 'Banners & MRECs',
                            id: '___ios_ad_formats_banner_ads',
                            isPage: true,
                            url: '/documentation/mediation/ios/ad-formats/banners',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/ad-formats/interstitials',
                            displayName: 'Interstitials',
                            id: '___ios_ad_formats_interstitial_ads',
                            isPage: true,
                            url: '/documentation/mediation/ios/ad-formats/interstitials',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/ad-formats/native-templates',
                            displayName: 'Native (Templates)',
                            id: '___ios_ad_formats_native_templates',
                            isPage: true,
                            url: '/documentation/mediation/ios/ad-formats/native-templates',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/ad-formats/native-manual',
                            displayName: 'Native (Manual)',
                            id: '___ios_ad_formats_native_manual',
                            isPage: true,
                            url: '/documentation/mediation/ios/ad-formats/native-manual',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/ad-formats/native-ad-placer',
                            displayName: 'Native (Ad Placer)',
                            id: '___ios_ad_formats_native_ad_placer',
                            isPage: true,
                            url: '/documentation/mediation/ios/ad-formats/native-ad-placer',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/ios/ad-formats/rewarded-ads',
                            displayName: 'Rewarded',
                            id: '___ios_ad_formats_rewarded_ads',
                            isPage: true,
                            url: '/documentation/mediation/ios/ad-formats/rewarded-ads',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Preparing Mediated Networks',
                id: '__ios_mediation_adapters',
                isPage: true,
                url: '/documentation/mediation/ios/mediation-adapters',
                children: [],
            },
            {
                breadcrumbUrl: '/documentation/mediation/ios/mediation-setup',
                displayName: 'Mediated Network Guides',
                id: '__ios_mediation_setup',
                isPage: true,
                url: '/documentation/mediation/ios/mediation-setup',
                children:
                    [
                        {
                            displayName: 'Bidders',
                            id: '___ios_mediation_setup_bidders',
                            isPage: true,
                            url: '/documentation/mediation/ios/mediation-setup/bidders',
                            children:
                                [
                                    {
                                        displayName: 'Amazon',
                                        id: '___ios_mediation_setup_amazon',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/amazon',
                                        children: [],
                                    },
                                    {
                                        displayName: 'BidMachine',
                                        id: '___ios_mediation_setup_bidmachine',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/bidmachine',
                                        children: [],
                                    },
                                    {
                                        displayName: 'DT Exchange',
                                        id: '___ios_mediation_setup_fyber',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/fyber-marketplace',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Google',
                                        id: '___ios_mediation_setup_google',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/google',
                                        children: [],
                                    },
                                    {
                                        displayName: 'InMobi',
                                        id: '___ios_mediation_setup_inmobi',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/inmobi',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Liftoff Monetize',
                                        id: '___ios_mediation_setup_liftoff',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/liftoff',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Meta Audience Network',
                                        id: '___ios_mediation_setup_facebook',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/facebook',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Mintegral',
                                        id: '___ios_mediation_setup_mintegral',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/mintegral',
                                        children: [],
                                    },
                                    {
                                        displayName: 'MobileFuse',
                                        id: '___ios_mediation_setup_mobilefuse',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/mobilefuse',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Ogury',
                                        id: '___ios_mediation_setup_ogury_presage',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/ogury-presage',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Pangle',
                                        id: '___ios_mediation_setup_tiktok',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/pangle',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Smaato',
                                        id: '___ios_mediation_setup_smaato',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/smaato',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Unity Ads',
                                        id: '___ios_mediation_setup_unityads',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/unityads',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Verve',
                                        id: '___ios_mediation_setup_verve',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/verve',
                                        children: [],
                                    },
                                    {
                                        displayName: 'VK Ad Network',
                                        id: '___ios_mediation_setup_vkadnetwork',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/vkadnetwork',
                                        children: [],
                                    },
                                ],
                        },
                        {
                            displayName: 'Others',
                            id: '___ios_mediation_setup_others',
                            isPage: true,
                            url: '/documentation/mediation/ios/mediation-setup/others',
                            children:
                                [
                                    {
                                        displayName: 'AdMob',
                                        id: '___ios_mediation_setup_admob',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/admob',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Chartboost',
                                        id: '___ios_mediation_setup_chartboost',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/chartboost',
                                        children: [],
                                    },
                                    {
                                        displayName: 'CSJ',
                                        id: '___ios_mediation_setup_csj',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/csj',
                                        children: [],
                                    },
                                    {
                                        displayName: 'HyprMX',
                                        id: '___ios_mediation_setup_hyprmx',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/hyprmx',
                                        children: [],
                                    },
                                    {
                                        displayName: 'IronSource',
                                        id: '___ios_mediation_setup_ironsource',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/ironsource',
                                        children: [],
                                    },
                                    {
                                        displayName: 'LINE',
                                        id: '___ios_mediation_setup_line',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/line',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Maio',
                                        id: '___ios_mediation_setup_maio',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/maio',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Tencent',
                                        id: '___ios_mediation_setup_tencent',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/tencent',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Yandex',
                                        id: '___ios_mediation_setup_yandex',
                                        isPage: true,
                                        url: '/documentation/mediation/ios/mediation-setup/yandex',
                                        children: [],
                                    },
                                ]
                        },
                        {
                            displayName: 'Custom SDK Networks',
                            id: '___ios_mediation_setup_custom_sdk',
                            isPage: true,
                            url: '/documentation/mediation/ios/mediation-setup/custom-sdk',
                            children: []
                        }
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/ios/testing-networks/test-mode',
                displayName: 'Testing Networks',
                id: '__ios_testing_networks',
                isPage: true,
                url: '/documentation/mediation/ios/testing-networks',
                children:
                    [
                        {
                            displayName: 'Demo App',
                            id: '___ios_demo_app',
                            isPage: true,
                            url: '/documentation/mediation/ios/testing-networks/demo-app',
                            children: [],
                        },
                        {
                            displayName: 'Creative Debugger',
                            id: '___ios_creative_debugger',
                            isPage: true,
                            url: '/documentation/mediation/ios/testing-networks/creative-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Mediation Debugger',
                            id: '___ios_mediation_debugger',
                            isPage: true,
                            url: '/documentation/mediation/ios/testing-networks/mediation-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Test Mode',
                            id: '___ios_test_mode',
                            isPage: true,
                            url: '/documentation/mediation/ios/testing-networks/test-mode',
                            children: [],
                        },
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/ios/changelog',
                displayName: 'Changelog',
                id: '__ios_sdk_change_logs',
                isPage: true,
                url: '/documentation/mediation/ios/changelog',
                children: [],
            },
        ],
};
const CORDOVA_DOCS_MENU = {
    breadcrumbUrl: '/documentation/mediation/cordova/getting-started/integration',
    displayName: 'Cordova',
    id: '_cordova',
    isPage: true,
    url: '/documentation/mediation/cordova',
    children:
        [
            {
                displayName: 'Overview',
                id: '__cordova_getting_started',
                isPage: true,
                url: '/documentation/mediation/cordova/getting-started',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/cordova/getting-started/integration',
                            displayName: 'Integration',
                            id: '___cordova_getting_started_integration',
                            isPage: true,
                            url: '/documentation/mediation/cordova/getting-started/integration',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/cordova/getting-started/privacy',
                            displayName: 'Privacy',
                            id: '___cordova_getting_started_privacy',
                            isPage: true,
                            url: '/documentation/mediation/cordova/getting-started/privacy',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/cordova/getting-started/apple-privacy-manifests',
                            displayName: 'Privacy Manifests',
                            id: '___cordova_getting_started_apple_manifests',
                            isPage: true,
                            url: '/documentation/mediation/cordova/getting-started/apple-privacy-manifests',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/cordova/getting-started/errorcodes',
                            displayName: 'Error Handling',
                            id: '___cordova_getting_started_errorcodes',
                            isPage: true,
                            url: '/documentation/mediation/cordova/getting-started/errorcodes',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/cordova/getting-started/skadnetwork-info',
                            displayName: 'SKAdNetwork',
                            id: '___cordova_getting_started_skadnetwork_info',
                            isPage: true,
                            url: '/documentation/mediation/cordova/getting-started/skadnetwork-info',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/cordova/getting-started/data-passing',
                            displayName: 'Data and Keyword Passing',
                            id: '___cordova_getting_started_data_passing',
                            isPage: true,
                            url: '/documentation/mediation/cordova/getting-started/data-passing',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/cordova/getting-started/advanced-settings',
                            displayName: 'Advanced Settings',
                            id: '___cordova_getting_started_advanced_settings',
                            isPage: true,
                            url: '/documentation/mediation/cordova/getting-started/advanced-settings',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Ad Formats',
                id: '__cordova_ad_formats',
                isPage: true,
                url: '/documentation/mediation/cordova/ad-formats',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/cordova/ad-formats/banners',
                            displayName: 'Banners & MRECs',
                            id: '___cordova_ad_formats_banner_ads',
                            isPage: true,
                            url: '/documentation/mediation/cordova/ad-formats/banners',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/cordova/ad-formats/interstitials',
                            displayName: 'Interstitials',
                            id: '___cordova_ad_formats_interstitial_ads',
                            isPage: true,
                            url: '/documentation/mediation/cordova/ad-formats/interstitials',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/cordova/ad-formats/rewarded-ads',
                            displayName: 'Rewarded',
                            id: '___cordova_ad_formats_rewarded_ads',
                            isPage: true,
                            url: '/documentation/mediation/cordova/ad-formats/rewarded-ads',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Preparing Mediated Networks',
                id: '__cordova_native_mediation_adapters',
                isPage: true,
                url: '/documentation/mediation/cordova/mediation-adapters',
                children: [
                    {
                        breadcrumbUrl: '/documentation/mediation/cordova/mediation-adapters/android',
                        id: '___cordova_getting_started_mediation_adapters_android',
                        displayName: 'Android',
                        isPage: true,
                        url: '/documentation/mediation/cordova/mediation-adapters/android',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/cordova/mediation-adapters/ios',
                        id: '___cordova_getting_started_mediation_adapters_ios',
                        displayName: 'iOS',
                        isPage: true,
                        url: '/documentation/mediation/cordova/mediation-adapters/ios',
                        children: [],
                    }
                ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/cordova/mediation-setup',
                displayName: 'Mediated Network Guides',
                id: '__cordova_mediation_setup',
                isPage: true,
                url: '/documentation/mediation/cordova/mediation-setup',
                children:
                    [
                        {
                            displayName: 'Bidders',
                            id: '___cordova_mediation_setup_bidders',
                            isPage: true,
                            url: '/documentation/mediation/cordova/mediation-setup/bidders',
                            children:
                                [
                                    {
                                        displayName: 'BidMachine',
                                        id: '___cordova_mediation_setup_bidmachine',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/bidmachine',
                                        children: [],
                                    },
                                    {
                                        displayName: 'DT Exchange',
                                        id: '___cordova_mediation_setup_fyber',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/fyber-marketplace',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Google',
                                        id: '___cordova_mediation_setup_google',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/google',
                                        children: [],
                                    },
                                    {
                                        displayName: 'InMobi',
                                        id: '___cordova_mediation_setup_inmobi',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/inmobi',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Meta Audience Network',
                                        id: '___cordova_mediation_setup_facebook',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/facebook',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Mintegral',
                                        id: '___cordova_mediation_setup_mintegral',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/mintegral',
                                        children: [],
                                    },
                                    // {
                                    //     displayName: 'Ogury',
                                    //     id: '___cordova_mediation_setup_ogury',
                                    //     isPage: true,
                                    //     url: '/documentation/mediation/cordova/mediation-setup/ogury',
                                    //     children: [],
                                    // },
                                    {
                                        displayName: 'Pangle',
                                        id: '___cordova_mediation_setup_tiktok',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/pangle',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Unity Ads',
                                        id: '___cordova_mediation_setup_unityads',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/unityads',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Verve',
                                        id: '___cordova_mediation_setup_verve',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/verve',
                                        children: [],
                                    },
                                    {
                                        displayName: 'VK Ad Network',
                                        id: '___cordova_mediation_setup_vkadnetwork',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/vkadnetwork',
                                        children: [],
                                    },
                                ],
                        },
                        {
                            displayName: 'Others',
                            id: '___cordova_mediation_setup_others',
                            isPage: true,
                            url: '/documentation/mediation/cordova/mediation-setup/others',
                            children:
                                [
                                    {
                                        displayName: 'AdMob',
                                        id: '___cordova_mediation_setup_admob',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/admob',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Chartboost',
                                        id: '___cordova_mediation_setup_chartboost',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/chartboost',
                                        children: [],
                                    },
                                    {
                                        displayName: 'CSJ',
                                        id: '___cordova_mediation_setup_csj',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/csj',
                                        children: [],
                                    },
                                    {
                                        displayName: 'HyprMX',
                                        id: '___cordova_mediation_setup_hyprmx',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/hyprmx',
                                        children: [],
                                    },
                                    {
                                        displayName: 'IronSource',
                                        id: '___cordova_mediation_setup_ironsource',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/ironsource',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Liftoff Monetize',
                                        id: '___cordova_mediation_setup_liftoff',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/liftoff',
                                        children: [],
                                    },
                                    {
                                        displayName: 'LINE',
                                        id: '___cordova_mediation_setup_line',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/line',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Maio',
                                        id: '___cordova_mediation_setup_maio',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/maio',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Smaato',
                                        id: '___cordova_mediation_setup_smaato',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/smaato',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Tencent',
                                        id: '___cordova_mediation_setup_tencent',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/tencent',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Yandex',
                                        id: '___cordova_mediation_setup_yandex',
                                        isPage: true,
                                        url: '/documentation/mediation/cordova/mediation-setup/yandex',
                                        children: [],
                                    },
                                ]
                        },
                        {
                            displayName: 'Custom SDK Networks',
                            id: '___cordova_mediation_setup_custom_sdk',
                            isPage: true,
                            url: '/documentation/mediation/cordova/mediation-setup/custom-sdk',
                            children: []
                        }
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/cordova/testing-networks/test-mode',
                displayName: 'Testing Networks',
                id: '__cordova_testing_networks',
                isPage: true,
                url: '/documentation/mediation/cordova/testing-networks',
                children:
                    [
                        {
                            displayName: 'Demo App',
                            id: '___cordova_demo_app',
                            isPage: true,
                            url: '/documentation/mediation/cordova/testing-networks/demo-app',
                            children: [],
                        },
                        {
                            displayName: 'Creative Debugger',
                            id: '___cordova_creative_debugger',
                            isPage: true,
                            url: '/documentation/mediation/cordova/testing-networks/creative-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Mediation Debugger',
                            id: '___cordova_mediation_debugger',
                            isPage: true,
                            url: '/documentation/mediation/cordova/testing-networks/mediation-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Test Mode',
                            id: '___cordova_test_mode',
                            isPage: true,
                            url: '/documentation/mediation/cordova/testing-networks/test-mode',
                            children: [],
                        },
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/cordova/changelog',
                displayName: 'Changelog',
                id: '__cordova_sdk_change_logs',
                isPage: true,
                url: '/documentation/mediation/cordova/changelog',
                children: [],
            },
        ],
};

const DEFOLD_DOCS_MENU = {
    breadcrumbUrl: '/documentation/mediation/defold/getting-started/integration',
    displayName: 'Defold',
    id: '_defold',
    isPage: true,
    url: '/documentation/mediation/defold',
    children:
        [
            {
                displayName: 'Overview',
                id: '__defold_getting_started',
                isPage: true,
                url: '/documentation/mediation/defold/getting-started',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/defold/getting-started/integration',
                            displayName: 'Integration',
                            id: '___defold_getting_started_integration',
                            isPage: true,
                            url: '/documentation/mediation/defold/getting-started/integration',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/defold/getting-started/terms-and-privacy-policy-flow',
                            displayName: 'Terms and Privacy Policy Flow',
                            id: '___defold_getting_started_terms_and_privacy_policy_flow',
                            isPage: true,
                            url: '/documentation/mediation/defold/getting-started/terms-and-privacy-policy-flow',
                            children: []
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/defold/getting-started/privacy',
                            displayName: 'Privacy',
                            id: '___defold_getting_started_privacy',
                            isPage: true,
                            url: '/documentation/mediation/defold/getting-started/privacy',
                            children: []
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/defold/getting-started/apple-privacy-manifests',
                            displayName: 'Privacy Manifests',
                            id: '___defold_getting_started_apple_manifests',
                            isPage: true,
                            url: '/documentation/mediation/defold/getting-started/apple-privacy-manifests',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/defold/getting-started/errorcodes',
                            displayName: 'Error Handling',
                            id: '___defold_getting_started_errorcodes',
                            isPage: true,
                            url: '/documentation/mediation/defold/getting-started/errorcodes',
                            children: []
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/defold/getting-started/skadnetwork-info',
                            displayName: 'SKAdNetwork',
                            id: '___defold_getting_started_skadnetwork_info',
                            isPage: true,
                            url: '/documentation/mediation/defold/getting-started/skadnetwork-info',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/defold/getting-started/advanced-settings',
                            displayName: 'Advanced Settings',
                            id: '___defold_getting_started_advanced_settings',
                            isPage: true,
                            url: '/documentation/mediation/defold/getting-started/advanced-settings',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Ad Formats',
                id: '__defold_ad_formats',
                isPage: true,
                url: '/documentation/mediation/defold/ad-formats',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/defold/ad-formats/banners',
                            displayName: 'Banners & MRECs',
                            id: '___defold_ad_formats_banner_ads',
                            isPage: true,
                            url: '/documentation/mediation/defold/ad-formats/banners',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/defold/ad-formats/interstitials',
                            displayName: 'Interstitials',
                            id: '___defold_ad_formats_interstitial_ads',
                            isPage: true,
                            url: '/documentation/mediation/defold/ad-formats/interstitials',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/defold/ad-formats/rewarded-ads',
                            displayName: 'Rewarded',
                            id: '___defold_ad_formats_rewarded_ads',
                            isPage: true,
                            url: '/documentation/mediation/defold/ad-formats/rewarded-ads',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Preparing Mediated Networks',
                id: '__defold_native_mediation_adapters',
                isPage: true,
                url: '/documentation/mediation/defold/mediation-adapters',
                children: [
                    {
                        breadcrumbUrl: '/documentation/mediation/defold/mediation-adapters/android',
                        id: '___defold_getting_started_mediation_adapters_android',
                        displayName: 'Android',
                        isPage: true,
                        url: '/documentation/mediation/defold/mediation-adapters/android',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/defold/mediation-adapters/ios',
                        id: '___defold_getting_started_mediation_adapters_ios',
                        displayName: 'iOS',
                        isPage: true,
                        url: '/documentation/mediation/defold/mediation-adapters/ios',
                        children: [],
                    }
                ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/defold/mediation-setup',
                displayName: 'Mediated Network Guides',
                id: '__defold_mediation_setup',
                isPage: true,
                url: '/documentation/mediation/defold/mediation-setup',
                children:
                    [
                        {
                            displayName: 'Bidders',
                            id: '___defold_mediation_setup_bidders',
                            isPage: true,
                            url: '/documentation/mediation/defold/mediation-setup/bidders',
                            children:
                                [
                                    {
                                        displayName: 'BidMachine',
                                        id: '___defold_mediation_setup_bidmachine',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/bidmachine',
                                        children: [],
                                    },
                                    {
                                        displayName: 'DT Exchange',
                                        id: '___defold_mediation_setup_fyber',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/fyber-marketplace',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Google',
                                        id: '___defold_mediation_setup_google',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/google',
                                        children: [],
                                    },
                                    {
                                        displayName: 'InMobi',
                                        id: '___defold_mediation_setup_inmobi',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/inmobi',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Liftoff Monetize',
                                        id: '___defold_mediation_setup_liftoff',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/liftoff',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Meta Audience Network',
                                        id: '___defold_mediation_setup_facebook',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/facebook',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Mintegral',
                                        id: '___defold_mediation_setup_mintegral',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/mintegral',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Ogury',
                                        id: '___defold_mediation_setup_ogury_presage',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/ogury-presage',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Pangle',
                                        id: '___defold_mediation_setup_tiktok',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/pangle',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Smaato',
                                        id: '___defold_mediation_setup_smaato',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/smaato',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Unity Ads',
                                        id: '___defold_mediation_setup_unityads',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/unityads',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Verve',
                                        id: '___defold_mediation_setup_verve',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/verve',
                                        children: [],
                                    },
                                    {
                                        displayName: 'VK Ad Network',
                                        id: '___defold_mediation_setup_vkadnetwork',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/vkadnetwork',
                                        children: [],
                                    },
                                ]
                        },
                        {
                            displayName: 'Others',
                            id: '___defold_mediation_setup_Others',
                            isPage: true,
                            url: '/documentation/mediation/defold/mediation-setup/others',
                            children:
                                [

                                    {
                                        displayName: 'AdMob',
                                        id: '___defold_mediation_setup_admob',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/admob',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Chartboost',
                                        id: '___defold_mediation_setup_chartboost',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/chartboost',
                                        children: [],
                                    },
                                    {
                                        displayName: 'CSJ',
                                        id: '___defold_mediation_setup_csj',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/csj',
                                        children: [],
                                    },
                                    {
                                        displayName: 'HyprMX',
                                        id: '___defold_mediation_setup_hyprmx',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/hyprmx',
                                        children: [],
                                    },
                                    {
                                        displayName: 'IronSource',
                                        id: '___defold_mediation_setup_ironsource',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/ironsource',
                                        children: [],
                                    },
                                    {
                                        displayName: 'LINE',
                                        id: '___defold_mediation_setup_line',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/line',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Maio',
                                        id: '___defold_mediation_setup_maio',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/maio',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Tencent',
                                        id: '___defold_mediation_setup_tencent',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/tencent',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Yandex',
                                        id: '___defold_mediation_setup_yandex',
                                        isPage: true,
                                        url: '/documentation/mediation/defold/mediation-setup/yandex',
                                        children: []
                                    },
                                ]
                        },
                        {
                            displayName: 'Custom SDK Networks',
                            id: '___defold_mediation_setup_custom_sdk',
                            isPage: true,
                            url: '/documentation/mediation/defold/mediation-setup/custom-sdk',
                            children: []
                        }
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/defold/testing-networks/test-mode',
                displayName: 'Testing Networks',
                id: '__defold_testing_networks',
                isPage: true,
                url: '/documentation/mediation/defold/testing-networks',
                children:
                    [
                        {
                            displayName: 'Demo App',
                            id: '___defold_demo_app',
                            isPage: true,
                            url: '/documentation/mediation/defold/testing-networks/demo-app',
                            children: [],
                        },
                        {
                            displayName: 'Creative Debugger',
                            id: '___defold_creative_debugger',
                            isPage: true,
                            url: '/documentation/mediation/defold/testing-networks/creative-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Mediation Debugger',
                            id: '___defold_mediation_debugger',
                            isPage: true,
                            url: '/documentation/mediation/defold/testing-networks/mediation-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Test Mode',
                            id: '___defold_test_mode',
                            isPage: true,
                            url: '/documentation/mediation/defold/testing-networks/test-mode',
                            children: [],
                        },
                    ]
            },
        ],
};

const FLUTTER_DOCS_MENU = {
    breadcrumbUrl: '/documentation/mediation/flutter/getting-started/integration',
    displayName: 'Flutter',
    id: '_flutter',
    isPage: true,
    url: '/documentation/mediation/flutter',
    children:
        [
            {
                displayName: 'Overview',
                id: '__flutter_getting_started',
                isPage: true,
                url: '/documentation/mediation/flutter/getting-started',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/flutter/getting-started/integration',
                            displayName: 'Integration',
                            id: '___flutter_getting_started_integration',
                            isPage: true,
                            url: '/documentation/mediation/flutter/getting-started/integration',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/flutter/getting-started/terms-and-privacy-policy-flow',
                            displayName: 'Terms and Privacy Policy Flow',
                            id: '___flutter_getting_started_terms_and_privacy_policy_flow',
                            isPage: true,
                            url: '/documentation/mediation/flutter/getting-started/terms-and-privacy-policy-flow',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/flutter/getting-started/privacy',
                            displayName: 'Privacy',
                            id: '___flutter_getting_started_privacy',
                            isPage: true,
                            url: '/documentation/mediation/flutter/getting-started/privacy',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/flutter/getting-started/apple-privacy-manifests',
                            displayName: 'Privacy Manifests',
                            id: '___flutter_getting_started_apple_manifests',
                            isPage: true,
                            url: '/documentation/mediation/flutter/getting-started/apple-privacy-manifests',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/flutter/getting-started/errorcodes',
                            displayName: 'Error Codes',
                            id: '___flutter_getting_started_errorcodes',
                            isPage: true,
                            url: '/documentation/mediation/flutter/getting-started/errorcodes',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/flutter/getting-started/skadnetwork-info',
                            displayName: 'SKAdNetwork',
                            id: '___flutter_getting_started_skadnetwork_info',
                            isPage: true,
                            url: '/documentation/mediation/flutter/getting-started/skadnetwork-info',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/flutter/getting-started/data-passing',
                            displayName: 'Data and Keyword Passing',
                            id: '___flutter_getting_started_data_passing',
                            isPage: true,
                            url: '/documentation/mediation/flutter/getting-started/data-passing',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/flutter/getting-started/advanced-settings',
                            displayName: 'Advanced Settings',
                            id: '___flutter_getting_started_advanced_settings',
                            isPage: true,
                            url: '/documentation/mediation/flutter/getting-started/advanced-settings',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Ad Formats',
                id: '__flutter_ad_formats',
                isPage: true,
                url: '/documentation/mediation/flutter/ad-formats',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/flutter/ad-formats/app-open',
                            displayName: 'App Open',
                            id: '___flutter_ad_formats_app_open',
                            isPage: true,
                            url: '/documentation/mediation/flutter/ad-formats/app-open',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/flutter/ad-formats/banners',
                            displayName: 'Banners & MRECs',
                            id: '___flutter_ad_formats_banner_ads',
                            isPage: true,
                            url: '/documentation/mediation/flutter/ad-formats/banners',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/flutter/ad-formats/interstitials',
                            displayName: 'Interstitials',
                            id: '___flutter_ad_formats_interstitial_ads',
                            isPage: true,
                            url: '/documentation/mediation/flutter/ad-formats/interstitials',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/flutter/ad-formats/native-manual',
                            displayName: 'Native',
                            id: '___flutter_ad_formats_native_manual',
                            isPage: true,
                            url: '/documentation/mediation/flutter/ad-formats/native-manual',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/flutter/ad-formats/rewarded-ads',
                            displayName: 'Rewarded',
                            id: '___flutter_ad_formats_rewarded_ads',
                            isPage: true,
                            url: '/documentation/mediation/flutter/ad-formats/rewarded-ads',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Preparing Mediated Networks',
                id: '__flutter_mediation_adapters',
                isPage: true,
                url: '/documentation/mediation/flutter/mediation-adapters',
                children: [
                    {
                        breadcrumbUrl: '/documentation/mediation/flutter/mediation-adapters/android',
                        id: '___flutter_getting_started_mediation_adapters_android',
                        displayName: 'Android',
                        isPage: true,
                        url: '/documentation/mediation/flutter/mediation-adapters/android',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/flutter/mediation-adapters/ios',
                        id: '___flutter_getting_started_mediation_adapters_ios',
                        displayName: 'iOS',
                        isPage: true,
                        url: '/documentation/mediation/flutter/mediation-adapters/ios',
                        children: [],
                    }
                ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/flutter/mediation-setup',
                displayName: 'Mediated Network Guides',
                id: '__flutter_mediation_setup',
                isPage: true,
                url: '/documentation/mediation/flutter/mediation-setup',
                children:
                    [
                        {
                            displayName: 'Bidders',
                            id: '___flutter_mediation_setup_bidders',
                            isPage: true,
                            url: '/documentation/mediation/flutter/mediation-setup/bidders',
                            children:
                                [
                                    {
                                        displayName: 'BidMachine',
                                        id: '___flutter_mediation_setup_bidmachine',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/bidmachine',
                                        children: [],
                                    },
                                    {
                                        displayName: 'DT Exchange',
                                        id: '___flutter_mediation_setup_fyber',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/fyber-marketplace',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Google',
                                        id: '___flutter_mediation_setup_google',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/google',
                                        children: [],
                                    },
                                    {
                                        displayName: 'InMobi',
                                        id: '___flutter_mediation_setup_inmobi',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/inmobi',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Meta Audience Network',
                                        id: '___flutter_mediation_setup_facebook',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/facebook',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Mintegral',
                                        id: '___flutter_mediation_setup_mintegral',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/mintegral',
                                        children: [],
                                    },
                                    // {
                                    //     displayName: 'Ogury',
                                    //     id: '___flutter_mediation_setup_ogury',
                                    //     isPage: true,
                                    //     url: '/documentation/mediation/flutter/mediation-setup/ogury',
                                    //     children: [],
                                    // },
                                    {
                                        displayName: 'Pangle',
                                        id: '___flutter_mediation_setup_tiktok',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/pangle',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Unity Ads',
                                        id: '___flutter_mediation_setup_unityads',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/unityads',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Verve',
                                        id: '___flutter_mediation_setup_verve',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/verve',
                                        children: [],
                                    },
                                    {
                                        displayName: 'VK Ad Network',
                                        id: '___flutter_mediation_setup_vkadnetwork',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/vkadnetwork',
                                        children: [],
                                    },
                                ],
                        },
                        {
                            displayName: 'Others',
                            id: '___flutter_mediation_setup_others',
                            isPage: true,
                            url: '/documentation/mediation/flutter/mediation-setup/others',
                            children:
                                [
                                    {
                                        displayName: 'AdMob',
                                        id: '___flutter_mediation_setup_admob',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/admob',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Chartboost',
                                        id: '___flutter_mediation_setup_chartboost',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/chartboost',
                                        children: [],
                                    },
                                    {
                                        displayName: 'CSJ',
                                        id: '___flutter_mediation_setup_csj',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/csj',
                                        children: [],
                                    },
                                    {
                                        displayName: 'HyprMX',
                                        id: '___flutter_mediation_setup_hyprmx',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/hyprmx',
                                        children: [],
                                    },
                                    {
                                        displayName: 'IronSource',
                                        id: '___flutter_mediation_setup_ironsource',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/ironsource',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Liftoff Monetize',
                                        id: '___flutter_mediation_setup_liftoff',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/liftoff',
                                        children: [],
                                    },
                                    {
                                        displayName: 'LINE',
                                        id: '___flutter_mediation_setup_line',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/line',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Maio',
                                        id: '___flutter_mediation_setup_maio',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/maio',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Smaato',
                                        id: '___flutter_mediation_setup_smaato',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/smaato',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Tencent',
                                        id: '___flutter_mediation_setup_tencent',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/tencent',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Yandex',
                                        id: '___flutter_mediation_setup_yandex',
                                        isPage: true,
                                        url: '/documentation/mediation/flutter/mediation-setup/yandex',
                                        children: [],
                                    },
                                ]
                        },
                        {
                            displayName: 'Custom SDK Networks',
                            id: '___flutter_mediation_setup_custom_sdk',
                            isPage: true,
                            url: '/documentation/mediation/flutter/mediation-setup/custom-sdk',
                            children: []
                        }
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/flutter/testing-networks/test-mode',
                displayName: 'Testing Networks',
                id: '__flutter_testing_networks',
                isPage: true,
                url: '/documentation/mediation/flutter/testing-networks',
                children:
                    [
                        {
                            displayName: 'Demo App',
                            id: '___flutter_demo_app',
                            isPage: true,
                            url: '/documentation/mediation/flutter/testing-networks/demo-app',
                            children: [],
                        },
                        {
                            displayName: 'Creative Debugger',
                            id: '___flutter_creative_bugger',
                            isPage: true,
                            url: '/documentation/mediation/flutter/testing-networks/creative-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Mediation Debugger',
                            id: '___flutter_mediation_debugger',
                            isPage: true,
                            url: '/documentation/mediation/flutter/testing-networks/mediation-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Test Mode',
                            id: '___flutter_test_mode',
                            isPage: true,
                            url: '/documentation/mediation/flutter/testing-networks/test-mode',
                            children: [],
                        },
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/flutter/changelog',
                displayName: 'Changelog',
                id: '__flutter_sdk_change_logs',
                isPage: true,
                url: '/documentation/mediation/flutter/changelog',
                children: [],
            },
        ],
};

const GODOT_DOCS_MENU = {
    breadcrumbUrl: '/documentation/mediation/godot/getting-started/integration',
    displayName: 'Godot',
    id: '_godot',
    isPage: true,
    url: '/documentation/mediation/godot',
    children:
        [
            {
                displayName: 'Overview',
                id: '__godot_getting_started',
                isPage: true,
                url: '/documentation/mediation/godot/getting-started',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/godot/getting-started/integration',
                            displayName: 'Integration',
                            id: '___godot_getting_started_integration',
                            isPage: true,
                            url: '/documentation/mediation/godot/getting-started/integration',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/godot/getting-started/privacy',
                            displayName: 'Privacy',
                            id: '___godot_getting_started_privacy',
                            isPage: true,
                            url: '/documentation/mediation/godot/getting-started/privacy',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/godot/getting-started/apple-privacy-manifests',
                            displayName: 'Privacy Manifests',
                            id: '___godot_getting_started_apple_manifests',
                            isPage: true,
                            url: '/documentation/mediation/godot/getting-started/apple-privacy-manifests',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/godot/getting-started/errorcodes',
                            displayName: 'Error Codes',
                            id: '___godot_getting_started_errorcodes',
                            isPage: true,
                            url: '/documentation/mediation/godot/getting-started/errorcodes',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/godot/getting-started/skadnetwork-info',
                            displayName: 'SKAdNetwork',
                            id: '___godot_getting_started_skadnetwork_info',
                            isPage: true,
                            url: '/documentation/mediation/godot/getting-started/skadnetwork-info',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/godot/getting-started/data-passing',
                            displayName: 'Data and Keyword Passing',
                            id: '___godot_getting_started_data_passing',
                            isPage: true,
                            url: '/documentation/mediation/godot/getting-started/data-passing',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/godot/getting-started/advanced-settings',
                            displayName: 'Advanced Settings',
                            id: '___godot_getting_started_advanced_settings',
                            isPage: true,
                            url: '/documentation/mediation/godot/getting-started/advanced-settings',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Ad Formats',
                id: '__godot_ad_formats',
                isPage: true,
                url: '/documentation/mediation/godot/ad-formats',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/godot/ad-formats/app-open',
                            displayName: 'App Open',
                            id: '___godot_ad_formats_app_open',
                            isPage: true,
                            url: '/documentation/mediation/godot/ad-formats/app-open',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/godot/ad-formats/banners',
                            displayName: 'Banners & MRECs',
                            id: '___godot_ad_formats_banner_ads',
                            isPage: true,
                            url: '/documentation/mediation/godot/ad-formats/banners',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/godot/ad-formats/interstitials',
                            displayName: 'Interstitials',
                            id: '___godot_ad_formats_interstitial_ads',
                            isPage: true,
                            url: '/documentation/mediation/godot/ad-formats/interstitials',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/godot/ad-formats/rewarded-ads',
                            displayName: 'Rewarded',
                            id: '___godot_ad_formats_rewarded_ads',
                            isPage: true,
                            url: '/documentation/mediation/godot/ad-formats/rewarded-ads',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Preparing Mediated Networks',
                id: '__godot_mediation_adapters',
                isPage: true,
                url: '/documentation/mediation/godot/mediation-adapters',
                children: [
                    {
                        breadcrumbUrl: '/documentation/mediation/godot/mediation-adapters/android',
                        id: '___godot_getting_started_mediation_adapters_android',
                        displayName: 'Android',
                        isPage: true,
                        url: '/documentation/mediation/godot/mediation-adapters/android',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/godot/mediation-adapters/ios',
                        id: '___godot_getting_started_mediation_adapters_ios',
                        displayName: 'iOS',
                        isPage: true,
                        url: '/documentation/mediation/godot/mediation-adapters/ios',
                        children: [],
                    }
                ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/godot/mediation-setup',
                displayName: 'Mediated Network Guides',
                id: '__godot_mediation_setup',
                isPage: true,
                url: '/documentation/mediation/godot/mediation-setup',
                children:
                    [
                        {
                            displayName: 'Bidders',
                            id: '___godot_mediation_setup_bidders',
                            isPage: true,
                            url: '/documentation/mediation/godot/mediation-setup/bidders',
                            children:
                                [
                                    {
                                        displayName: 'BidMachine',
                                        id: '___godot_mediation_setup_bidmachine',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/bidmachine',
                                        children: [],
                                    },
                                    {
                                        displayName: 'DT Exchange',
                                        id: '___godot_mediation_setup_fyber',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/fyber-marketplace',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Google',
                                        id: '___godot_mediation_setup_google',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/google',
                                        children: [],
                                    },
                                    {
                                        displayName: 'InMobi',
                                        id: '___godot_mediation_setup_inmobi',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/inmobi',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Meta Audience Network',
                                        id: '___godot_mediation_setup_facebook',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/facebook',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Mintegral',
                                        id: '___godot_mediation_setup_mintegral',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/mintegral',
                                        children: [],
                                    },
                                    // {
                                    //     displayName: 'Ogury',
                                    //     id: '___godot_mediation_setup_ogury',
                                    //     isPage: true,
                                    //     url: '/documentation/mediation/godot/mediation-setup/ogury',
                                    //     children: [],
                                    // },
                                    {
                                        displayName: 'Pangle',
                                        id: '___godot_mediation_setup_tiktok',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/pangle',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Unity Ads',
                                        id: '___godot_mediation_setup_unityads',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/unityads',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Verve',
                                        id: '___godot_mediation_setup_verve',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/verve',
                                        children: [],
                                    },
                                    {
                                        displayName: 'VK Ad Network',
                                        id: '___godot_mediation_setup_vkadnetwork',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/vkadnetwork',
                                        children: [],
                                    },
                                ],
                        },
                        {
                            displayName: 'Others',
                            id: '___godot_mediation_setup_others',
                            isPage: true,
                            url: '/documentation/mediation/godot/mediation-setup/others',
                            children:
                                [
                                    {
                                        displayName: 'AdMob',
                                        id: '___godot_mediation_setup_admob',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/admob',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Chartboost',
                                        id: '___godot_mediation_setup_chartboost',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/chartboost',
                                        children: [],
                                    },
                                    {
                                        displayName: 'CSJ',
                                        id: '___godot_mediation_setup_csj',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/csj',
                                        children: [],
                                    },
                                    {
                                        displayName: 'HyprMX',
                                        id: '___godot_mediation_setup_hyprmx',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/hyprmx',
                                        children: [],
                                    },
                                    {
                                        displayName: 'IronSource',
                                        id: '___godot_mediation_setup_ironsource',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/ironsource',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Liftoff Monetize',
                                        id: '___godot_mediation_setup_liftoff',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/liftoff',
                                        children: [],
                                    },
                                    {
                                        displayName: 'LINE',
                                        id: '___godot_mediation_setup_line',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/line',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Maio',
                                        id: '___godot_mediation_setup_maio',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/maio',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Smaato',
                                        id: '___godot_mediation_setup_smaato',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/smaato',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Tencent',
                                        id: '___godot_mediation_setup_tencent',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/tencent',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Yandex',
                                        id: '___godot_mediation_setup_yandex',
                                        isPage: true,
                                        url: '/documentation/mediation/godot/mediation-setup/yandex',
                                        children: [],
                                    },
                                ]
                        },
                        {
                            displayName: 'Custom SDK Networks',
                            id: '___godot_mediation_setup_custom_sdk',
                            isPage: true,
                            url: '/documentation/mediation/godot/mediation-setup/custom-sdk',
                            children: []
                        }
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/godot/testing-networks/test-mode',
                displayName: 'Testing Networks',
                id: '__godot_testing_networks',
                isPage: true,
                url: '/documentation/mediation/godot/testing-networks',
                children:
                    [
                        {
                            displayName: 'Demo App',
                            id: '___godot_demo_app',
                            isPage: true,
                            url: '/documentation/mediation/godot/testing-networks/demo-app',
                            children: [],
                        },
                        {
                            displayName: 'Creative Debugger',
                            id: '___godot_creative_bugger',
                            isPage: true,
                            url: '/documentation/mediation/godot/testing-networks/creative-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Mediation Debugger',
                            id: '___godot_mediation_debugger',
                            isPage: true,
                            url: '/documentation/mediation/godot/testing-networks/mediation-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Test Mode',
                            id: '___godot_test_mode',
                            isPage: true,
                            url: '/documentation/mediation/godot/testing-networks/test-mode',
                            children: [],
                        },
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/godot/changelog',
                displayName: 'Changelog',
                id: '__godot_sdk_change_logs',
                isPage: true,
                url: '/documentation/mediation/godot/changelog',
                children: [],
            },
        ],
};

const REACT_NATIVE_DOCS_MENU = {
    breadcrumbUrl: '/documentation/mediation/react-native/getting-started/integration',
    displayName: 'React Native',
    id: '_react_native',
    isPage: true,
    url: '/documentation/mediation/react-native',
    children:
        [
            {
                displayName: 'Overview',
                id: '__react_native_getting_started',
                isPage: true,
                url: '/documentation/mediation/react-native/getting-started',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/getting-started/integration',
                            displayName: 'Integration',
                            id: '___react_native_getting_started_integration',
                            isPage: true,
                            url: '/documentation/mediation/react-native/getting-started/integration',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/getting-started/migration',
                            displayName: 'Migrating to Version 5',
                            id: '___react_native_getting_started_migration',
                            isPage: true,
                            url: '/documentation/mediation/react-native/getting-started/migration',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/getting-started/migration6',
                            displayName: 'Migrating to Version 6',
                            id: '___react_native_getting_started_migration6',
                            isPage: true,
                            url: '/documentation/mediation/react-native/getting-started/migration6',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/getting-started/terms-and-privacy-policy-flow',
                            displayName: 'Terms and Privacy Policy Flow',
                            id: '___react_native_getting_started_terms_and_privacy_policy_flow',
                            isPage: true,
                            url: '/documentation/mediation/react-native/getting-started/terms-and-privacy-policy-flow',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/getting-started/privacy',
                            displayName: 'Privacy',
                            id: '___react_native_getting_started_privacy',
                            isPage: true,
                            url: '/documentation/mediation/react-native/getting-started/privacy',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/getting-started/apple-privacy-manifests',
                            displayName: 'Privacy Manifests',
                            id: '___react_native_getting_started_apple_manifests',
                            isPage: true,
                            url: '/documentation/mediation/react-native/getting-started/apple-privacy-manifests',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/getting-started/errorcodes',
                            displayName: 'Error Handling',
                            id: '___react_native_getting_started_errorcodes',
                            isPage: true,
                            url: '/documentation/mediation/react-native/getting-started/errorcodes',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/getting-started/skadnetwork-info',
                            displayName: 'SKAdNetwork',
                            id: '___react_native_getting_started_skadnetwork_info',
                            isPage: true,
                            url: '/documentation/mediation/react-native/getting-started/skadnetwork-info',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/getting-started/data-passing',
                            displayName: 'Data and Keyword Passing',
                            id: '___react_native_getting_started_data_passing',
                            isPage: true,
                            url: '/documentation/mediation/react-native/getting-started/data-passing',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/getting-started/advanced-settings',
                            displayName: 'Advanced Settings',
                            id: '___react_native_getting_started_advanced_settings',
                            isPage: true,
                            url: '/documentation/mediation/react-native/getting-started/advanced-settings',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Ad Formats',
                id: '__react_native_ad_formats',
                isPage: true,
                url: '/documentation/mediation/react-native/ad-formats',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/ad-formats/app-open',
                            displayName: 'App Open',
                            id: '___react_native_ad_formats_app_open',
                            isPage: true,
                            url: '/documentation/mediation/react-native/ad-formats/app-open',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/ad-formats/banners',
                            displayName: 'Banners & MRECs',
                            id: '___react_native_ad_formats_banner_ads',
                            isPage: true,
                            url: '/documentation/mediation/react-native/ad-formats/banners',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/ad-formats/interstitials',
                            displayName: 'Interstitials',
                            id: '___react_native_ad_formats_interstitial_ads',
                            isPage: true,
                            url: '/documentation/mediation/react-native/ad-formats/interstitials',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/ad-formats/native-manual',
                            displayName: 'Native',
                            id: '___react_native_ad_formats_native_manual',
                            isPage: true,
                            url: '/documentation/mediation/react-native/ad-formats/native-manual',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/react-native/ad-formats/rewarded-ads',
                            displayName: 'Rewarded',
                            id: '___react_native_ad_formats_rewarded_ads',
                            isPage: true,
                            url: '/documentation/mediation/react-native/ad-formats/rewarded-ads',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Preparing Mediated Networks',
                id: '__react_native_mediation_adapters',
                isPage: true,
                url: '/documentation/mediation/react-native/mediation-adapters',
                children: [
                    {
                        breadcrumbUrl: '/documentation/mediation/react-native/mediation-adapters/android',
                        id: '___react_native_getting_started_mediation_adapters_android',
                        displayName: 'Android',
                        isPage: true,
                        url: '/documentation/mediation/react-native/mediation-adapters/android',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/react-native/mediation-adapters/ios',
                        id: '___react_native_getting_started_mediation_adapters_ios',
                        displayName: 'iOS',
                        isPage: true,
                        url: '/documentation/mediation/react-native/mediation-adapters/ios',
                        children: [],
                    }
                ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/react-native/mediation-setup',
                displayName: 'Mediated Network Guides',
                id: '__react_native_mediation_setup',
                isPage: true,
                url: '/documentation/mediation/react-native/mediation-setup',
                children:
                    [
                        {
                            displayName: 'Bidders',
                            id: '___react_native_mediation_setup_bidders',
                            isPage: true,
                            url: '/documentation/mediation/react-native/mediation-setup/bidders',
                            children:
                                [
                                    {
                                        displayName: 'Bidamchine',
                                        id: '___react_native_mediation_setup_bidmachine',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/bidmachine',
                                        children: [],
                                    },
                                    {
                                        displayName: 'DT Exchange',
                                        id: '___react_native_mediation_setup_fyber',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/fyber-marketplace',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Google',
                                        id: '___react_native_mediation_setup_google',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/google',
                                        children: [],
                                    },
                                    {
                                        displayName: 'InMobi',
                                        id: '___react_native_mediation_setup_inmobi',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/inmobi',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Meta Audience Network',
                                        id: '___react_native_mediation_setup_facebook',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/facebook',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Mintegral',
                                        id: '___react_native_mediation_setup_mintegral',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/mintegral',
                                        children: [],
                                    },
                                    // {
                                    //     displayName: 'Ogury',
                                    //     id: '___react_native_mediation_setup_ogury',
                                    //     isPage: true,
                                    //     url: '/documentation/mediation/react-native/mediation-setup/ogury',
                                    //     children: [],
                                    // },
                                    {
                                        displayName: 'Pangle',
                                        id: '___react_native_mediation_setup_tiktok',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/pangle',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Unity Ads',
                                        id: '___react_native_mediation_setup_unityads',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/unityads',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Verve',
                                        id: '___react_native_mediation_setup_verve',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/verve',
                                        children: [],
                                    },
                                    {
                                        displayName: 'VK Ad Network',
                                        id: '___react_native_mediation_setup_vkadnetwork',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/vkadnetwork',
                                        children: [],
                                    },
                                ],
                        },
                        {
                            displayName: 'Others',
                            id: '___react_native_mediation_setup_others',
                            isPage: true,
                            url: '/documentation/mediation/react-native/mediation-setup/others',
                            children:
                                [
                                    {
                                        displayName: 'AdMob',
                                        id: '___react_native_mediation_setup_admob',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/admob',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Chartboost',
                                        id: '___react_native_mediation_setup_chartboost',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/chartboost',
                                        children: [],
                                    },
                                    {
                                        displayName: 'CSJ',
                                        id: '___react_native_mediation_setup_csj',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/csj',
                                        children: [],
                                    },
                                    {
                                        displayName: 'HyprMX',
                                        id: '___react_native_mediation_setup_hyprmx',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/hyprmx',
                                        children: [],
                                    },
                                    {
                                        displayName: 'IronSource',
                                        id: '___react_native_mediation_setup_ironsource',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/ironsource',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Liftoff Monetize',
                                        id: '___react_native_mediation_setup_liftoff',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/liftoff',
                                        children: [],
                                    },
                                    {
                                        displayName: 'LINE',
                                        id: '___react_native_mediation_setup_line',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/line',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Maio',
                                        id: '___react_native_mediation_setup_maio',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/maio',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Smaato',
                                        id: '___react_native_mediation_setup_smaato',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/smaato',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Tencent',
                                        id: '___react_native_mediation_setup_tencent',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/tencent',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Yandex',
                                        id: '___react_native_mediation_setup_yandex',
                                        isPage: true,
                                        url: '/documentation/mediation/react-native/mediation-setup/yandex',
                                        children: [],
                                    },
                                ]
                        },
                        {
                            displayName: 'Custom SDK Networks',
                            id: '___react_native_mediation_setup_custom_sdk',
                            isPage: true,
                            url: '/documentation/mediation/react-native/mediation-setup/custom-sdk',
                            children: []
                        }
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/react-native/testing-networks/test-mode',
                displayName: 'Testing Networks',
                id: '__react_native_testing_networks',
                isPage: true,
                url: '/documentation/mediation/react-native/testing-networks',
                children:
                    [
                        {
                            displayName: 'Demo App',
                            id: '___react_native_demo_app',
                            isPage: true,
                            url: '/documentation/mediation/react-native/testing-networks/demo-app',
                            children: [],
                        },
                        {
                            displayName: 'Creative Debugger',
                            id: '___react_native_creative_bugger',
                            isPage: true,
                            url: '/documentation/mediation/react-native/testing-networks/creative-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Mediation Debugger',
                            id: '___react_native_mediation_debugger',
                            isPage: true,
                            url: '/documentation/mediation/react-native/testing-networks/mediation-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Test Mode',
                            id: '___react_native_test_mode',
                            isPage: true,
                            url: '/documentation/mediation/react-native/testing-networks/test-mode',
                            children: [],
                        },
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/react-native/changelog',
                displayName: 'Changelog',
                id: '__react_native_sdk_change_logs',
                isPage: true,
                url: '/documentation/mediation/react-native/changelog',
                children: [],
            },
        ],
};

const UNREAL_DOCS_MENU = {
    breadcrumbUrl: '/documentation/mediation/unreal/getting-started/integration',
    displayName: 'Unreal',
    id: '_unreal',
    isPage: true,
    url: '/documentation/mediation/unreal',
    children:
        [
            {
                displayName: 'Overview',
                id: '__unreal_getting_started',
                isPage: true,
                url: '/documentation/mediation/unreal/getting-started',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/unreal/getting-started/integration',
                            displayName: 'Integration',
                            id: '___unreal_getting_started_integration',
                            isPage: true,
                            url: '/documentation/mediation/unreal/getting-started/integration',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unreal/getting-started/terms-and-privacy-policy-flow',
                            displayName: 'Terms and Privacy Policy Flow',
                            id: '___unreal_getting_started_terms_and_privacy_policy_flow',
                            isPage: true,
                            url: '/documentation/mediation/unreal/getting-started/terms-and-privacy-policy-flow',
                            children: []
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unreal/getting-started/privacy',
                            displayName: 'Privacy',
                            id: '___unreal_getting_started_privacy',
                            isPage: true,
                            url: '/documentation/mediation/unreal/getting-started/privacy',
                            children: []
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unreal/getting-started/apple-privacy-manifests',
                            displayName: 'Privacy Manifests',
                            id: '___unreal_getting_started_apple_manifests',
                            isPage: true,
                            url: '/documentation/mediation/unreal/getting-started/apple-privacy-manifests',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unreal/getting-started/errorcodes',
                            displayName: 'Error Handling',
                            id: '___unreal_getting_started_errorcodes',
                            isPage: true,
                            url: '/documentation/mediation/unreal/getting-started/errorcodes',
                            children: []
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unreal/getting-started/skadnetwork-info',
                            displayName: 'SKAdNetwork',
                            id: '___unreal_getting_started_skadnetwork_info',
                            isPage: true,
                            url: '/documentation/mediation/unreal/getting-started/skadnetwork-info',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unreal/getting-started/advanced-settings',
                            displayName: 'Advanced Settings',
                            id: '___unreal_getting_started_advanced_settings',
                            isPage: true,
                            url: '/documentation/mediation/unreal/getting-started/advanced-settings',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Ad Formats',
                id: '__unreal_ad_formats',
                isPage: true,
                url: '/documentation/mediation/unreal/ad-formats',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/unreal/ad-formats/banners',
                            displayName: 'Banners & MRECs',
                            id: '___unreal_ad_formats_banner_ads',
                            isPage: true,
                            url: '/documentation/mediation/unreal/ad-formats/banners',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unreal/ad-formats/interstitials',
                            displayName: 'Interstitials',
                            id: '___unreal_ad_formats_interstitial_ads',
                            isPage: true,
                            url: '/documentation/mediation/unreal/ad-formats/interstitials',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unreal/ad-formats/rewarded-ads',
                            displayName: 'Rewarded',
                            id: '___unreal_ad_formats_rewarded_ads',
                            isPage: true,
                            url: '/documentation/mediation/unreal/ad-formats/rewarded-ads',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Preparing Mediated Networks',
                id: '__unreal_native_mediation_adapters',
                isPage: true,
                url: '/documentation/mediation/unreal/mediation-adapters',
                children: [
                    {
                        breadcrumbUrl: '/documentation/mediation/unreal/mediation-adapters/android',
                        id: '___unreal_getting_started_mediation_adapters_android',
                        displayName: 'Android',
                        isPage: true,
                        url: '/documentation/mediation/unreal/mediation-adapters/android',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/unreal/mediation-adapters/ios',
                        id: '___unreal_getting_started_mediation_adapters_ios',
                        displayName: 'iOS',
                        isPage: true,
                        url: '/documentation/mediation/unreal/mediation-adapters/ios',
                        children: [],
                    }
                ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/unreal/mediation-setup',
                displayName: 'Mediated Network Guides',
                id: '__unreal_mediation_setup',
                isPage: true,
                url: '/documentation/mediation/unreal/mediation-setup',
                children:
                    [
                        {
                            displayName: 'Bidders',
                            id: '___unreal_mediation_setup_bidders',
                            isPage: true,
                            url: '/documentation/mediation/unreal/mediation-setup/bidders',
                            children:
                                [
                                    {
                                        displayName: 'BidMachine',
                                        id: '___unreal_mediation_setup_bidmachine',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/bidmachine',
                                        children: [],
                                    },
                                    {
                                        displayName: 'DT Exchange',
                                        id: '___unreal_mediation_setup_fyber',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/fyber-marketplace',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Google',
                                        id: '___unreal_mediation_setup_google',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/google',
                                        children: [],
                                    },
                                    {
                                        displayName: 'InMobi',
                                        id: '___unreal_mediation_setup_inmobi',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/inmobi',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Liftoff Monetize',
                                        id: '___unreal_mediation_setup_liftoff',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/liftoff',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Meta Audience Network',
                                        id: '___unreal_mediation_setup_facebook',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/facebook',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Mintegral',
                                        id: '___unreal_mediation_setup_mintegral',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/mintegral',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Ogury',
                                        id: '___unreal_mediation_setup_ogury_presage',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/ogury-presage',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Pangle',
                                        id: '___unreal_mediation_setup_tiktok',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/pangle',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Smaato',
                                        id: '___unreal_mediation_setup_smaato',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/smaato',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Unity Ads',
                                        id: '___unreal_mediation_setup_unityads',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/unityads',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Verve',
                                        id: '___unreal_mediation_setup_verve',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/verve',
                                        children: [],
                                    },
                                    {
                                        displayName: 'VK Ad Network',
                                        id: '___unreal_mediation_setup_vkadnetwork',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/vkadnetwork',
                                        children: [],
                                    },
                                ]
                        },
                        {
                            displayName: 'Others',
                            id: '___unreal_mediation_setup_Others',
                            isPage: true,
                            url: '/documentation/mediation/unreal/mediation-setup/others',
                            children:
                                [

                                    {
                                        displayName: 'AdMob',
                                        id: '___unreal_mediation_setup_admob',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/admob',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Chartboost',
                                        id: '___unreal_mediation_setup_chartboost',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/chartboost',
                                        children: [],
                                    },
                                    {
                                        displayName: 'CSJ',
                                        id: '___unreal_mediation_setup_csj',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/csj',
                                        children: [],
                                    },
                                    {
                                        displayName: 'HyprMX',
                                        id: '___unreal_mediation_setup_hyprmx',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/hyprmx',
                                        children: [],
                                    },
                                    {
                                        displayName: 'IronSource',
                                        id: '___unreal_mediation_setup_ironsource',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/ironsource',
                                        children: [],
                                    },
                                    {
                                        displayName: 'LINE',
                                        id: '___unreal_mediation_setup_line',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/line',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Maio',
                                        id: '___unreal_mediation_setup_maio',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/maio',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Tencent',
                                        id: '___unreal_mediation_setup_tencent',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/tencent',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Yandex',
                                        id: '___unreal_mediation_setup_yandex',
                                        isPage: true,
                                        url: '/documentation/mediation/unreal/mediation-setup/yandex',
                                        children: []
                                    },
                                ]
                        },
                        {
                            displayName: 'Custom SDK Networks',
                            id: '___unreal_mediation_setup_custom_sdk',
                            isPage: true,
                            url: '/documentation/mediation/unreal/mediation-setup/custom-sdk',
                            children: []
                        }
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/unreal/testing-networks/test-mode',
                displayName: 'Testing Networks',
                id: '__unreal_testing_networks',
                isPage: true,
                url: '/documentation/mediation/unreal/testing-networks',
                children:
                    [
                        {
                            displayName: 'Demo App',
                            id: '___unreal_demo_app',
                            isPage: true,
                            url: '/documentation/mediation/unreal/testing-networks/demo-app',
                            children: [],
                        },
                        {
                            displayName: 'Creative Debugger',
                            id: '___unreal_creative_debugger',
                            isPage: true,
                            url: '/documentation/mediation/unreal/testing-networks/creative-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Mediation Debugger',
                            id: '___unreal_mediation_debugger',
                            isPage: true,
                            url: '/documentation/mediation/unreal/testing-networks/mediation-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Test Mode',
                            id: '___unreal_test_mode',
                            isPage: true,
                            url: '/documentation/mediation/unreal/testing-networks/test-mode',
                            children: [],
                        },
                    ]
            },
        ],
};

const UNITY_DOCS_MENU = {
    breadcrumbUrl: '/documentation/mediation/unity/getting-started/integration',
    displayName: 'Unity',
    id: '_unity',
    isPage: true,
    url: '/documentation/mediation/unity',
    children:
        [
            {
                displayName: 'Overview',
                id: '__unity_getting_started',
                isPage: true,
                url: '/documentation/mediation/unity/getting-started',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/unity/getting-started/integration',
                            displayName: 'Integration',
                            id: '___unity_getting_started_integration',
                            isPage: true,
                            url: '/documentation/mediation/unity/getting-started/integration',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unity/getting-started/terms-and-privacy-policy-flow',
                            displayName: 'Terms and Privacy Policy Flow',
                            id: '___unity_getting_started_terms_and_privacy_policy_flow',
                            isPage: true,
                            url: '/documentation/mediation/unity/getting-started/terms-and-privacy-policy-flow',
                            children: []
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unity/getting-started/privacy',
                            displayName: 'Privacy',
                            id: '___unity_getting_started_privacy',
                            isPage: true,
                            url: '/documentation/mediation/unity/getting-started/privacy',
                            children: []
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unity/getting-started/apple-privacy-manifests',
                            displayName: 'Privacy Manifests',
                            id: '___unity_getting_started_apple_manifests',
                            isPage: true,
                            url: '/documentation/mediation/unity/getting-started/apple-privacy-manifests',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unity/getting-started/errorcodes',
                            displayName: 'Error Handling',
                            id: '___unity_getting_started_errorcodes',
                            isPage: true,
                            url: '/documentation/mediation/unity/getting-started/errorcodes',
                            children: []
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unity/getting-started/data-passing',
                            displayName: 'Data and Keyword Passing',
                            id: '___unity_getting_started_data_passing',
                            isPage: true,
                            url: '/documentation/mediation/unity/getting-started/data-passing',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unity/getting-started/advanced-settings',
                            displayName: 'Advanced Settings',
                            id: '___unity_getting_started_advanced_settings',
                            isPage: true,
                            url: '/documentation/mediation/unity/getting-started/advanced-settings',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Ad Formats',
                id: '__unity_ad_formats',
                isPage: true,
                url: '/documentation/mediation/unity/ad-formats',
                children:
                    [
                        {
                            breadcrumbUrl: '/documentation/mediation/unity/ad-formats/app-open',
                            displayName: 'App Open',
                            id: '___unity_ad_formats_app_open',
                            isPage: true,
                            url: '/documentation/mediation/unity/ad-formats/app-open',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unity/ad-formats/banners',
                            displayName: 'Banners & MRECs',
                            id: '___unity_ad_formats_banner_ads',
                            isPage: true,
                            url: '/documentation/mediation/unity/ad-formats/banners',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unity/ad-formats/interstitials',
                            displayName: 'Interstitials',
                            id: '___unity_ad_formats_interstitial_ads',
                            isPage: true,
                            url: '/documentation/mediation/unity/ad-formats/interstitials',
                            children: [],
                        },
                        {
                            breadcrumbUrl: '/documentation/mediation/unity/ad-formats/rewarded-ads',
                            displayName: 'Rewarded',
                            id: '___unity_ad_formats_rewarded_ads',
                            isPage: true,
                            url: '/documentation/mediation/unity/ad-formats/rewarded-ads',
                            children: [],
                        },
                    ],
            },
            {
                displayName: 'Preparing Mediated Networks',
                id: '__unity_mediation_adapters',
                isPage: true,
                url: '/documentation/mediation/unity/mediation-adapters',
                children: [],
            },
            {
                breadcrumbUrl: '/documentation/mediation/unity/mediation-setup',
                displayName: 'Mediated Network Guides',
                id: '__unity_mediation_setup',
                isPage: true,
                url: '/documentation/mediation/unity/mediation-setup',
                children:
                    [
                        {
                            displayName: 'Bidders',
                            id: '___unity_mediation_setup_bidders',
                            isPage: true,
                            url: '/documentation/mediation/unity/mediation-setup/bidders',
                            children:
                                [
                                    {
                                        displayName: 'Amazon',
                                        id: '___unity_mediation_setup_amazon',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/amazon',
                                        children: [],
                                    },
                                    {
                                        displayName: 'BidMachine',
                                        id: '___unity_mediation_setup_bidmachine',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/bidmachine',
                                        children: [],
                                    },
                                    {
                                        displayName: 'DT Exchange',
                                        id: '___unity_mediation_setup_fyber',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/fyber-marketplace',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Google',
                                        id: '___unity_mediation_setup_google',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/google',
                                        children: [],
                                    },
                                    {
                                        displayName: 'InMobi',
                                        id: '___unity_mediation_setup_inmobi',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/inmobi',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Liftoff Monetize',
                                        id: '___unity_mediation_setup_liftoff',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/liftoff',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Meta Audience Network',
                                        id: '___unity_mediation_setup_facebook',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/facebook',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Mintegral',
                                        id: '___unity_mediation_setup_mintegral',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/mintegral',
                                        children: [],
                                    },
                                    {
                                        displayName: 'MobileFuse',
                                        id: '___unity_mediation_setup_mobilefuse',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/mobilefuse',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Ogury',
                                        id: '___unity_mediation_setup_ogury_presage',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/ogury-presage',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Pangle',
                                        id: '___unity_mediation_setup_tiktok',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/pangle',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Smaato',
                                        id: '___unity_mediation_setup_smaato',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/smaato',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Unity Ads',
                                        id: '___unity_mediation_setup_unityads',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/unityads',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Verve',
                                        id: '___unity_mediation_setup_verve',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/verve',
                                        children: [],
                                    },
                                    {
                                        displayName: 'VK Ad Network',
                                        id: '___unity_mediation_setup_vkadnetwork',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/vkadnetwork',
                                        children: [],
                                    },
                                ]
                        },
                        {
                            displayName: 'Others',
                            id: '___unity_mediation_setup_Others',
                            isPage: true,
                            url: '/documentation/mediation/unity/mediation-setup/others',
                            children:
                                [

                                    {
                                        displayName: 'AdMob',
                                        id: '___unity_mediation_setup_admob',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/admob',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Chartboost',
                                        id: '___unity_mediation_setup_chartboost',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/chartboost',
                                        children: [],
                                    },
                                    {
                                        displayName: 'CSJ',
                                        id: '___unity_mediation_setup_csj',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/csj',
                                        children: [],
                                    },
                                    {
                                        displayName: 'HyprMX',
                                        id: '___unity_mediation_setup_hyprmx',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/hyprmx',
                                        children: [],
                                    },
                                    {
                                        displayName: 'IronSource',
                                        id: '___unity_mediation_setup_ironsource',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/ironsource',
                                        children: [],
                                    },
                                    {
                                        displayName: 'LINE',
                                        id: '___unity_mediation_setup_line',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/line',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Maio',
                                        id: '___unity_mediation_setup_maio',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/maio',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Tencent',
                                        id: '___unity_mediation_setup_tencent',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/tencent',
                                        children: [],
                                    },
                                    {
                                        displayName: 'Yandex',
                                        id: '___unity_mediation_setup_yandex',
                                        isPage: true,
                                        url: '/documentation/mediation/unity/mediation-setup/yandex',
                                        children: []
                                    },
                                ]
                        },
                        {
                            displayName: 'Custom SDK Networks',
                            id: '___unity_mediation_setup_custom_sdk',
                            isPage: true,
                            url: '/documentation/mediation/unity/mediation-setup/custom-sdk',
                            children: []
                        }
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/unity/testing-networks/test-mode',
                displayName: 'Testing Networks',
                id: '__unity_testing_networks',
                isPage: true,
                url: '/documentation/mediation/unity/testing-networks',
                children:
                    [
                        {
                            displayName: 'Demo App',
                            id: '___unity_demo_app',
                            isPage: true,
                            url: '/documentation/mediation/unity/testing-networks/demo-app',
                            children: [],
                        },
                        {
                            displayName: 'Creative Debugger',
                            id: '___unity_creative_debugger',
                            isPage: true,
                            url: '/documentation/mediation/unity/testing-networks/creative-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Mediation Debugger',
                            id: '___unity_mediation_debugger',
                            isPage: true,
                            url: '/documentation/mediation/unity/testing-networks/mediation-debugger',
                            children: [],
                        },
                        {
                            displayName: 'Test Mode',
                            id: '___unity_test_mode',
                            isPage: true,
                            url: '/documentation/mediation/unity/testing-networks/test-mode',
                            children: [],
                        },
                    ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/unity/changelog',
                displayName: 'Changelog',
                id: '__unity_sdk_change_logs',
                isPage: true,
                url: '/documentation/mediation/unity/changelog',
                children: [],
            },
        ],
};
export const DOCS_LEFT_MENU: DocsMenuSection =
    {
        displayName: 'Documentation',
        id: 'mediation',
        isPage: true,
        url: '/documentation/mediation',
        children: [
            GET_STARTED_WITH_MAX_MENU,
            MAX_UI_MENU,
            MAX_AUCTIONS,
            ADOBE_AIR_DOCS_MENU,
            ANDROID_DOCS_MENU,
            CORDOVA_DOCS_MENU,
            DEFOLD_DOCS_MENU,
            FLUTTER_DOCS_MENU,
            GODOT_DOCS_MENU,
            IOS_DOCS_MENU,
            REACT_NATIVE_DOCS_MENU,
            UNITY_DOCS_MENU,
            UNREAL_DOCS_MENU,
            {
                breadcrumbUrl: '/documentation/mediation/reporting-api/',
                displayName: 'Reporting APIs',
                id: '_reporting_apis',
                isPage: true,
                url: '/documentation/mediation/reporting-api/',
                children: [
                    {
                        breadcrumbUrl: '/documentation/mediation/reporting-api/max-ad-revenue',
                        displayName: 'Ad Revenue',
                        id: '__max_reporting_api',
                        isPage: true,
                        url: '/documentation/mediation/reporting-api/max-ad-revenue',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/reporting-api/user-ad-revenue',
                        displayName: 'User Ad Revenue',
                        id: '__user_revenue_api',
                        isPage: true,
                        url: '/documentation/mediation/reporting-api/user-ad-revenue',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/reporting-api/max-cohort',
                        displayName: 'Cohort',
                        id: '__max_cohort_api',
                        isPage: true,
                        url: '/documentation/mediation/reporting-api/max-cohort',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/reporting-api/direct-sold',
                        displayName: 'Direct Sold',
                        id: '__max_direct_sold_api',
                        isPage: true,
                        url: '/documentation/mediation/reporting-api/direct-sold',
                        children: [],
                    },
                ]
            },
            {
                breadcrumbUrl: '/documentation/mediation/ad-review',
                displayName: 'Ad Review',
                id: '_ad_review',
                isPage: true,
                url: '/documentation/mediation/ad-review',
                children: [
                    {
                        breadcrumbUrl: '/documentation/mediation/ad-review/overview',
                        displayName: 'Overview',
                        id: '_ad_review_overview',
                        isPage: true,
                        url: '/documentation/mediation/ad-review/overview',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/ad-review/creative-review',
                        displayName: 'Creative Review',
                        id: '_creative_review',
                        isPage: true,
                        url: '/documentation/mediation/ad-review/creative-review',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/ad-review/user-journey',
                        displayName: 'User Journey',
                        id: '_user_journey',
                        isPage: true,
                        url: '/documentation/mediation/ad-review/user-journey',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/ad-review/campaign-analysis',
                        displayName: 'Campaign Analysis',
                        id: '_campaign_analysis',
                        isPage: true,
                        url: '/documentation/mediation/ad-review/campaign-analysis',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/ad-review/risky-content-detection',
                        displayName: 'Risky Content Detection',
                        id: '_risky_content_detection',
                        isPage: true,
                        url: '/documentation/mediation/ad-review/risky-content-detection',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/ad-review/competitor-monitoring',
                        displayName: 'Competitor Monitoring',
                        id: '_competitor_monitoring',
                        isPage: true,
                        url: '/documentation/mediation/ad-review/competitor-monitoring',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/ad-review/ad-reporting',
                        displayName: 'Ad Reporting',
                        id: '_ad_reporting',
                        isPage: true,
                        url: '/documentation/mediation/ad-review/ad-reporting',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/ad-review/auto-redirects',
                        displayName: 'Auto Redirects',
                        id: '_auto_redirects',
                        isPage: true,
                        url: '/documentation/mediation/ad-review/auto-redirects',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/ad-review/rules-management',
                        displayName: 'Rules Management API',
                        id: '_rules_management',
                        isPage: true,
                        url: '/documentation/mediation/ad-review/rules-management',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/ad-review/faq',
                        displayName: 'Frequently Asked Questions',
                        id: '_ad_review_faq',
                        isPage: true,
                        url: '/documentation/mediation/ad-review/faq',
                        children: [],
                    },
                ],
            },
            {
                breadcrumbUrl: '/documentation/mediation/features/ab-test',
                displayName: 'Advanced Features',
                id: '_max_features',
                isPage: true,
                url: '/documentation/mediation/features',
                children: [
                    {
                        breadcrumbUrl: '/documentation/mediation/features/ab-test',
                        displayName: 'A/B Testing',
                        id: '_ab_test',
                        isPage: true,
                        url: '/documentation/mediation/features/ab-test',
                        children:
                            [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/features/custom-implementations',
                        displayName: 'Custom Implementations',
                        id: '__custom_implementations',
                        isPage: true,
                        url: '/documentation/mediation/features/custom-implementations',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/features/direct-sold',
                        displayName: 'Direct Sold',
                        id: '__direct_sold',
                        isPage: true,
                        url: '/documentation/mediation/features/direct-sold',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/features/ad-unit-automation-api',
                        displayName: 'Management API',
                        id: '__ad_unit_automation_api',
                        isPage: true,
                        url: '/documentation/mediation/features/ad-unit-automation-api',
                        children: [],
                    },
                    // {
                    //     breadcrumbUrl: '/documentation/mediation/s2s-rewarded-callback-api',
                    //     displayName: 'S2S Rewarded Callback API',
                    //     id: '__s2s_rewarded_callback_api',
                    //     isPage: true,
                    //     url: '/documentation/mediation/s2s-rewarded-callback-api',
                    //     children: [],
                    // },
                    {
                        breadcrumbUrl: '/documentation/mediation/features/s2s-impression-revenue-api',
                        displayName: 'S2S Impression Revenue API',
                        id: '__s2s_impression_revenue_api',
                        isPage: true,
                        url: '/documentation/mediation/features/s2s-impression-revenue-api',
                        children: [],
                    },
                    {
                        breadcrumbUrl: '/documentation/mediation/features/waterfall-segmentation',
                        displayName: 'Waterfall Segmentation and Cloning',
                        id: '_waterfall_segmentation',
                        isPage: true,
                        url: '/documentation/mediation/features/waterfall-segmentation',
                        children: [],
                    }
                ]
            },
            {
                breadcrumbUrl: '',
                displayName: 'Success Stories',
                id: '_success',
                isPage: false,
                url: 'https://www.applovin.com/success-stories/',
                children: []
            },
            {
                breadcrumbUrl: '',
                displayName: 'Help Center',
                id: '_help_center',
                isPage: false,
                url: 'https://www.applovin.com/support/',
                children: []
            },
        ],
    };
